export const Mascaras = {
    mascaraCNPJ: [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/],
    mascaraCPF: [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
    mascaraCelular: ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    mascaraTelefone: ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    mascaraCEP: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
    mascaraData: [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /[1-2]/, /\d/, /\d/, /\d/],
    mascaraCH: [/\d/, /\d/, /\d/, /\d/],
    mascaraQtdAvaliacoes: [/[1-9]/, /[0-9]/],
    mascaraCertificadoProdFor: ['PRODFOR ', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/],

    mascaraTelCel(value) {
        if (value.length <= 14) {
            return ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        }
        return ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    },
    mascaraCPF_CNPJ(value) {
        if (value.length <= 14) {
            return [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
        }
        return [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    }
};

export const ChaveAcao = {
    AGENDAR_AUDITORIA_AUDITOR: 'AGENDAR_AUDITORIA_AUDITOR',
    AGENDAR_AUDITORIA_FORNECEDOR: 'AGENDAR_AUDITORIA_FORNECEDOR',
    ALTERAR_DADOS_AUDITORIA: 'ALTERAR_DADOS_AUDITORIA',
    ANALISE_FASE1_APROVAR: 'ANALISE_FASE1_APROVAR',
    ANALISE_FASE1_APR_RESSALVAS: 'ANALISE_FASE1_APR_RESSALVAS',
    ANALISE_FASE1_PENDENTE: 'ANALISE_FASE1_PENDENTE',
    APROVAR_AUDITORIA_FASE1: 'APROVAR_AUDITORIA_FASE1',
    APROVAR_AVALIACOES_CE: 'APROVAR_AVALIACOES_CE',
    APROVAR_CADASTRO: 'APROVAR_CADASTRO',
    APROVAR_CERTIFICADO: 'APROVAR_CERTIFICADO',
    APROVAR_DOCUMENTACAO_AUD_GT: 'APROVAR_DOCUMENTACAO_AUD_GT',
    APROVAR_PEDIDO_SOLICITACAO: 'APROVAR_REPROVAR_PEDIDO_SOLICITACAO',
    APROVAR_SISTEMA_GESTAO_AUDITOR: 'APROVAR_SISTEMA_GESTAO_AUDITOR',
    EXECUTAR_AUDITORIA_FASE2: 'EXECUTAR_AUDITORIA_FASE2',
    EXECUTAR_AUDITORIA_FASE2_NC: 'EXECUTAR_AUDITORIA_FASE2_NC',
    FINALIZAR_AVALIACOES: 'FINALIZAR_AVALIACOES',
    FINALIZAR_DESENVOLVIMENTO_AVALIACOES: 'FINALIZAR_DESENVOLVIMENTO_AVALIACOES',
    FORNECEDOR_FASE1: 'FORNECEDOR_FASE1',
    PARECER_AUDITORIA_CERTIFICACAO: 'PARECER_AUDITORIA_CERTIFICACAO',
    PLANO_ACAO_FASE1: 'PLANO_ACAO_FASE1',
    PLANO_ACAO_FASE2: 'PLANO_ACAO_FASE2',
    PROGRAMACAO_AUDITORIA: 'PROGRAMACAO_AUDITORIA',
    REGISTRAR_PARECER_SOL: 'REGISTRAR_PARECER_SOL',
    REJEITAR_PEDIDO_SOLICITACAO: 'APROVAR_REPROVAR_PEDIDO_SOLICITACAO',
    REPROVAR_AUDITORIA_FASE1: 'REPROVAR_AUDITORIA_FASE1',
    REPROVAR_AVALIACOES_CE: 'REPROVAR_AVALIACOES_CE',
    REPROVAR_CADASTRO: 'REPROVAR_CADASTRO',
    REPROVAR_CERTIFICADO: 'REPROVAR_CERTIFICADO',
    REPROVAR_DOCUMENTACAO_AUD_GT: 'REPROVAR_DOCUMENTACAO_AUD_GT',
    REPROVAR_SISTEMA_GESTAO_AUDITOR: 'REPROVAR_SISTEMA_GESTAO_AUDITOR',
    RETIRAR_QUALIFICACAO_AUD: 'RETIRAR_QUALIFICACAO_AUD',
    SUSPENDER_CANCELAR_CERTIFICADO: 'SUSPENDER_CANCELAR_CERTIFICADO',
    VALIDAR_CADASTRO_AUDITOR: 'VALIDAR_CADASTRO_AUDITOR',
    INDICACAO_ANALISE_AUDITOR: 'INDICACAO_ANALISE_AUDITOR',
    RESPONDER_PESQUISA_SATISFACAO: 'RESPONDER_PESQUISA_SATISFACAO',
    APROVAR_PLANO_FASE1: 'APROVAR_PLANO_FASE1',
    APROVAR_PLANO_FASE1_RESSALVAS: 'APROVAR_PLANO_FASE1_RESSALVAS',
    REPROVAR_PLANO_FASE1: 'REPROVAR_PLANO_FASE1',
    APROVAR_PLANO_FASE2: 'APROVAR_PLANO_FASE2',
    REPROVAR_PLANO_FASE2: 'REPROVAR_PLANO_FASE2',
    INDICACAO_ANALISE_COORDENADOR: 'INDICACAO_ANALISE_COORDENADOR',
    ENCAMINHAR_IEL: 'ENCAMINHAR_IEL',
    ENCAMINHAR_GT: 'ENCAMINHAR_GT',
    APROVAR_ITENS_CONSTATACAO_AUDITORIA: 'APROVAR_ITENS_CONSTATACAO_AUDITORIA',
    REPROVAR_ITENS_CONSTATACAO_AUDITORIA: 'REPROVAR_ITENS_CONSTATACAO_AUDITORIA',
    EXECUTAR_AUDITORIA_FASE2_REUNIAO_GT: 'EXECUTAR_AUDITORIA_FASE2_REUNIAO_GT',
    ACEITAR_CERTIFICADO_EXTERNO: 'ACEITAR_CERTIFICADO_EXTERNO',
    REJEITAR_CERTIFICADO_EXTERNO: 'REJEITAR_CERTIFICADO_EXTERNO',
    TRATAR_RESPOSTA_PESQUISA: 'TRATAR_RESPOSTA_PESQUISA',
    NAO_TRATAR_RESPOSTA_PESQUISA: 'NAO_TRATAR_RESPOSTA_PESQUISA',
    ENCAMINHAR_RESPOSTA_PESQUISA_CE: 'ENCAMINHAR_RESPOSTA_PESQUISA_CE',
    REJEITAR_RESPOSTA_PESQUISA: 'REJEITAR_RESPOSTA_PESQUISA',
};

export const TransacoesPerfil = {
    CRIAR_REUNIAO_CE: 'CRIAR_REUNIAO_CE',
    CRIAR_REUNIAO_GT: 'CRIAR_REUNIAO_GT',
    CRIAR_ENCONTRO_TECNICO: 'CRIAR_ENCONTRO_TECNICO',
    ANALISAR_CERTIFICADO_EXTERNO: 'ANALISAR_CERTIFICADO_EXTERNO'
};

export const statusCadastro = {
    EM_APROVACAO: 1,
    APROVADO: 2,
    SUSPENSO: 3,
    REPROVADO: 4
};

export const StatusConstatacao = {
    DEACORDO: 'De acordo',
    NAOACORDO: 'Não condordo',
    EMAPELACAO: 'Em apelação'
};

export const StatusSolicitacao = {
    ABERTA: '1',
    EM_ANALISE: '2',
    CONCLUIDA: '3',
    APROVADA: '4',
    REJEITADA: '5'
};

export const TipoSolicitacao = {
    APELACAO: '1',
    ALTERACAO: '2',
    CANCELAMENTO: '3',
    DESENVOLVIMENTO: '4',
    DESISTENCIA: '5',
    RECLAMACAO: '6',
    ALTERACAO_AUDITORIA: '7',
    ALTERACAO_ESCOPO: '8'
};

export const TipoSolicitacaoSelect = [
    { codigo: 1, chave: 'APELACAO', nome: 'Apelação' },
    { codigo: 2, chave: 'ALTERACAO', nome: 'Alteração Cadastro' },
    { codigo: 3, chave: 'CANCELAMENTO', nome: 'Cancelamento' },
    { codigo: 4, chave: 'DESENVOLVIMENTO', nome: 'Desenvolvimento' },
    { codigo: 5, chave: 'DESISTENCIA', nome: 'Desistencia' },
    { codigo: 6, chave: 'RECLAMACAO', nome: 'Reclamacao' },
    { codigo: 7, chave: 'ALTERACAO_AUDITORIA', nome: 'Alteração Auditoria' },
    { codigo: 8, chave: 'ALTERACAO_ESCOPO', nome: 'Alteração Escopo' }
];

export const InicioCertificacaoSelect = [
    { id: 3, text: 'Desenvolvimento IEL' },
    { id: 5, text: 'Fase I - Documentação' },
    { id: 9, text: 'Fase II - Auditoria' }
];

export const TipoAuditoriaSelect = [
    { codigo: 1, chave: 'CERTIFICACAO', nome: 'Certificação' },
    { codigo: 2, chave: 'PERIODICA', nome: 'Supervisão Periódica' },
    { codigo: 3, chave: 'RECERTIFICACAO', nome: 'Recertificação' },
    { codigo: 4, chave: 'ACOMPANHAMENTO', nome: 'Acompanhamento' },
    { codigo: 5, chave: 'EXTRAORDINARIA', nome: 'Extraordinária' },
    /* { codigo: 6, chave: 'PERIODICA_RECERTIFICACAO', nome: 'Periódica Recertificação' },
    { codigo: 7, chave: 'ACOMPANHAMENTO_RECERTIFICACAO', nome: 'Acompanhamento Recertificação' },
    { codigo: 8, chave: 'EXTRAORDINARIA_RECERTIFICACAO', nome: 'Extraordinária Recertificação' } */
];

export const TipoCertificado = [
    { codigo: 1, chave: 'EMDIA', nome: 'Em dia' },
    { codigo: 2, chave: 'CANCELADO', nome: 'Cancelado' },
    { codigo: 3, chave: 'REVISADO', nome: 'Revisado' },
    { codigo: 4, chave: 'VENCIDO', nome: 'Vencido' },
    { codigo: 5, chave: 'SUSPENSO', nome: 'Suspenso' },
    { codigo: 6, chave: 'EMPROCESSO', nome: 'Em processo de certificação' },
    { codigo: 7, chave: 'ANALISE_CERTIFICACAO_ISO', nome: 'Análise Certificação ISO' }
];

export const TipoPesquisaSatisfacao = [
    { codigo: 1, chave: 'INSATISFACAO', nome: 'Insatisfação' },
    { codigo: 2, chave: 'SATISFACAO', nome: 'Satisfação' }
];

export const TipoEvento = {
    ENCONTRO_TECNICO: 'Encontro técnico',
    REUNIAO_CE: 'Reunião CE',
    REUNIAO_GT: 'Reunião Revisor Técnico',
    AUDITORIA_PREVISTA: 'Auditoria prevista',
    AUDITORIA_PROGRAMADA: 'Auditoria programada',
    AUDITORIA_AGENDADA: 'Auditoria confirmada',
    AUDITORIA_SUSPENSA: 'Auditoria suspensa',
    AUDITORIA_FINALIZADA: 'Auditoria finalizada',
    AUDITORIA_CANCELADA: 'Auditoria cancelada'
};

export const CodTipoEvento = {
    ENCONTRO_TECNICO: '1',
    REUNIAO_CE: '2',
    REUNIAO_GT: '3',
    AUDITORIA_PREVISTA: '4',
    AUDITORIA_PROGRAMADA: '5',
    AUDITORIA_AGENDADA: '6',
    AUDITORIA_EXECUTADA: '7',
    AUDITORIA_FINALIZADA: '8',
    AUDITORIA_SUSPENSA: '9',
    AUDITORIA_CANCELADA: '10'
};

export const CodTipoPerfil = {
    INTERNO: 1,
    AUDITOR: 2,
    FORNECEDOR: 3
};

export const TipoAssuntoReuniao = {
    CADASTRO_FORNECEDOR: 'CADASTRO_FORNECEDOR',
    CADASTRO_AUDITOR: 'CADASTRO_AUDITOR',
    INICIO_AUDITORIA: 'INICIO_AUDITORIA',
    DESENV_ACOMPANHAMENTO: 'DESENV_ACOMPANHAMENTO',
    QUALIFICACAO: 'QUALIFICACAO',
    SOLICITACAO_FORNECEDOR: 'SOLICITACAO_FORNECEDOR',
    PESQUISA_SATISFACAO: 'PESQUISA_SATISFACAO',
    ANALISE_CERTIFICACAO_ISO: 'ANALISE_CERTIFICACAO_ISO'
};

export const CodEstacao = {
    ReuniaoCE_APROVAR_CAD_FORNECEDOR: '1',
    AprovacaoCadastroAuditor_VERIFICACAO_DADOS_AUDITOR: '2',
    ReuniaoCE_DESENV_ACOMPANHAMENTO: '3,4',
    FaseII_EXECUCAO_AUDITORIA: '11',
    FaseII_PLANO_ACAO_FORNECEDOR: '12',
    ReuniaoGT_QUALIFICACAO: '13',
    Qualificacao_ANALISE_RESULTADO_AUDITORIA: '13',
    ReuniaoCE_RESULTADO_QUALIFICACAO: '14',
    Qualificacao_CERTIFICACAO_AUDITORIA: '14',
    ReuniaoGT_SOLICITACAO_FORNECEDOR: '17',
    ReuniaoCE_INICIO_AUDITORIA: '19',
    ReuniaoGT_INICIO_AUDITORIA: '19',
    ReuniaoCE_SOLICITACAO_FORNECEDOR: '18',
    AprovacaoGTQualificacao_APROVAR_ANALISE_GT_DOCUMENTACAO: '20',
    ReuniaoCE_APROVAR_CAD_AUDITOR: '21',
    FaseI_Analise_Formulario_Auditor: '22',
    FaseI_Analise_Formulario_PlanoAcao: '24',
    FaseII_ANALISE_PLANO_ACAO_FORN: '25',
    FaseII_DEACORDO_FORN_OK: '26',
    FaseII_DEACORDO_FORN_NAO_CONFORMIDADE: '27',
    Solicitacao_EstacaoIEL: '28',
    FaseII_DEACORDO_FORN_CONSTATACAO: '29',
    ReuniaoCE_PESQUISA_SATISFACAO: '32', //32
    ArquivoCertificadoExternoAnalise: '31'
};

export const codAcao = {
    APROVAR_REPROVAR_PEDIDO_SOLICITACAO: 28,
    ENCAMINHAR_IEL: 50,
    ENCAMINHAR_GT: 51,
    REGISTRAR_PARECER_SOL: 27,
    REGISTRAR_PARECER_IEL: 52,
    FINALIZAR_SOLICITACAO_IEL: 53,
    FaseI_Analise_Formulario_PlanoAcao: '24',
    FaseII_ANALISE_PLANO_ACAO_FORN: '25',
    FaseII_DEACORDO_FORN_OK: '26',
    FaseII_DEACORDO_FORN_NAO_CONFORMIDADE: '27',
};

export const CodTipoAuditoria = {
    CERTIFICACAO: '1',
    PERIODICA: '2',
    RECERTIFICACAO: '3',
    ACOMPANHAMENTO: '4',
    EXTRAORDINARIA: '5',
    /* PERIODICA_RECERTIFICACAO: '6',
    ACOMPANHAMENTO_RECERTIFICACAO: '7',
    EXTRAORDINARIA_RECERTIFICACAO: '8', */
};

export const MotivoCancelamentoAuditoria = {
    FaltaRealizacaoAuditoria: '1',
    CertificacaoNaoEDiferencial: '2',
    SemInteresseManterCertificado: '3',
    MotivosFinanceiros: '4',
    DecisaoEstrategica: '5',
    PoucoServicoComMantenedora: '6',
    NaoApresentouCertificado: '7',
    SistemaGestaoParalizado: '8',
    EmpresaInativa: '9',
    OutrosMotivos: '10'
};

export const TipoEstacao = {
    APROVACAO_SG: 'Aprovação Sistema Gestão Auditor',
    AUDITORIAFASEI: 'Auditoria Fase I',
    AUDITORIAFASEII: 'Auditoria Fase II',
    CADASTRO: 'Cadastro',
    DESENVOLVIMENTO: 'Desenvolvimento',
    QUALIFICACAO: 'Qualificação',
    QUALIFICACAO_SG_AUDITOR: 'Qualificação Sistema Gestão Auditor'
};

export const StatusCertificado = {
    EMDIA: 'EMDIA',
    CANCELADO: 'CANCELADO',
    REVISADO: 'REVISADO',
    VENCIDO: 'VENCIDO',
    SUSPENSO: 'SUSPENSO',
    EMPROCESSO: 'EMPROCESSO',
    ANALISE_CERTIFICACAO_ISO: 'ANALISE_CERTIFICACAO_ISO'
};

export const codStatusCertificado = {
    EMDIA: 1,
    CANCELADO: 2,
    REVISADO: 3,
    VENCIDO: 4,
    SUSPENSO: 5,
    EMPROCESSO: 6,
    ANALISE_CERTIFICACAO_ISO: 7
};



export const ResultadoCertificacaoCE = [
    'Certificação', 'Não certificação', 'Recertificação', 'Não recertificação', 'Manuteção da certificação', 'Suspensão da certificação', 'Cancelamento da certificação'
]

export const ListaMesesCodigo = [
    { codigo: 0, mes: 'Janeiro' },
    { codigo: 1, mes: 'Fevereiro' },
    { codigo: 2, mes: 'Março' },
    { codigo: 3, mes: 'Abril' },
    { codigo: 4, mes: 'Maio' },
    { codigo: 5, mes: 'Junho' },
    { codigo: 6, mes: 'Julho' },
    { codigo: 7, mes: 'Agosto' },
    { codigo: 8, mes: 'Setembro' },
    { codigo: 9, mes: 'Outubro' },
    { codigo: 10, mes: 'Novembro' },
    { codigo: 11, mes: 'Dezembro' }
];


export const ListaMeses = ListaMesesCodigo.map(x => x.mes); // ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

export const ListaCamposObrigatoriosFornecedor = [
    '0cpf_cnpj', '0razaoSocial', '1cep', '1logradouro', '1numero', '1bairro', '1estado', '1cidade', '5nomeRepresentante', '5cpfRepresentante', '5rgRepresentante'
];

export const texturasGraficos = [
    { backgroundColor: 'rgba(  0, 255,   0, 0.5)', borderColor: 'rgba(  0, 255,   0, 1.0)' }, // verde
    { backgroundColor: 'rgba( 54, 162, 235, 0.5)', borderColor: 'rgba( 54, 162, 235, 1.0)' }, // azul
    { backgroundColor: 'rgba(240, 210,  60, 0.5)', borderColor: 'rgba(240, 210,  60, 1.0)' }, // amarelo
    { backgroundColor: 'rgba(240, 130,  30, 0.5)', borderColor: 'rgba(240, 130,  30, 1.0)' }, // laranja
    { backgroundColor: 'rgba( 30,   0,  60, 0.5)', borderColor: 'rgba( 30,   0,  60, 1.0)' }, // roxo
    { backgroundColor: 'rgba( 40, 210,  94, 0.5)', borderColor: 'rgba( 40, 210,  94, 1.0)' }, // lilas
    { backgroundColor: 'rgba(133, 162, 150, 0.5)', borderColor: 'rgba(133, 162, 150, 1.0)' },
    { backgroundColor: 'rgba( 54,  15, 235, 0.5)', borderColor: 'rgba( 54,  15, 235, 1.0)' },
    { backgroundColor: 'rgba(157, 100,  42, 0.5)', borderColor: 'rgba(157, 100,  42, 1.0)' },
    { backgroundColor: 'rgba(240, 242,  89, 0.5)', borderColor: 'rgba(240, 242,  89, 1.0)' },
    { backgroundColor: 'rgba(152, 203, 197, 0.5)', borderColor: 'rgba(152, 203, 197, 1.0)' },
    { backgroundColor: 'rgba(212, 230, 189, 0.5)', borderColor: 'rgba(212, 230, 189, 1.0)' },
    { backgroundColor: 'rgba(105, 214, 207, 0.5)', borderColor: 'rgba(105, 214, 207, 1.0)' },
    { backgroundColor: 'rgba(108,  40, 119, 0.5)', borderColor: 'rgba(108,  40, 119, 1.0)' },
    { backgroundColor: 'rgba(120, 162, 235, 0.5)', borderColor: 'rgba(120, 162, 235, 1.0)' },
    { backgroundColor: 'rgba(169, 214,  55, 0.5)', borderColor: 'rgba(169, 214,  55, 1.0)' },
    { backgroundColor: 'rgba(238,  35, 186, 0.5)', borderColor: 'rgba(238,  35, 186, 1.0)' }, // 16 - rosa
    { backgroundColor: 'rgba(125,  47,  84, 0.5)', borderColor: 'rgba(125,  47,  84, 1.0)' },
    { backgroundColor: 'rgba(215,  47,  96, 0.5)', borderColor: 'rgba(215,  47,  96, 1.0)' },
    { backgroundColor: 'rgba( 90, 207,  45, 0.5)', borderColor: 'rgba( 90, 207,  45, 1.0)' },
    { backgroundColor: 'rgba(  1, 242, 176, 0.5)', borderColor: 'rgba(  1, 242, 176, 1.0)' },
    { backgroundColor: 'rgba( 54, 162,  88, 0.5)', borderColor: 'rgba( 54, 162,  88, 1.0)' },
    { backgroundColor: 'rgba(201, 139,  16, 0.5)', borderColor: 'rgba(201, 139,  16, 1.0)' },
    { backgroundColor: 'rgba( 94, 200,  24, 0.5)', borderColor: 'rgba( 94, 200,  24, 1.0)' },
    { backgroundColor: 'rgba(192,  87, 110, 0.5)', borderColor: 'rgba(192,  87, 110, 1.0)' },
    { backgroundColor: 'rgba(253, 138, 254, 0.5)', borderColor: 'rgba(253, 138, 254, 1.0)' },
    { backgroundColor: 'rgba(117, 212,   9, 0.5)', borderColor: 'rgba(117, 212,   9, 1.0)' },
    { backgroundColor: 'rgba(255,   0,   0, 0.5)', borderColor: 'rgba(255,   0,   0, 1.0)' }, // vermelho
    { backgroundColor: 'rgba(239,  62,  43, 0.5)', borderColor: 'rgba(239,  62,  43, 1.0)' }, // próximo ao vermelho
    { backgroundColor: 'rgba(154, 167,  12, 0.5)', borderColor: 'rgba(154, 167,  12, 1.0)' },
    { backgroundColor: 'rgba( 16, 223, 127, 0.5)', borderColor: 'rgba( 16, 223, 127, 1.0)' },
    { backgroundColor: 'rgba(194, 107,  39, 0.5)', borderColor: 'rgba(194, 107,  39, 1.0)' },
    { backgroundColor: 'rgba(198, 236, 242, 0.5)', borderColor: 'rgba(198, 236, 242, 1.0)' },
    { backgroundColor: 'rgba( 83,  85, 155, 0.5)', borderColor: 'rgba( 83,  85, 155, 1.0)' },
    { backgroundColor: 'rgba(108, 159, 211, 0.5)', borderColor: 'rgba(108, 159, 211, 1.0)' },
    { backgroundColor: 'rgba(242,  55,  58, 0.5)', borderColor: 'rgba(242,  55,  58, 1.0)' },
    { backgroundColor: 'rgba(190, 164, 132, 0.5)', borderColor: 'rgba(190, 164, 132, 1.0)' },
    { backgroundColor: 'rgba( 14,  62, 207, 0.5)', borderColor: 'rgba( 14,  62, 207, 1.0)' },
    { backgroundColor: 'rgba(250, 167, 128, 0.5)', borderColor: 'rgba(250, 167, 128, 1.0)' },
    { backgroundColor: 'rgba( 51, 249,  79, 0.5)', borderColor: 'rgba( 51, 249,  79, 1.0)' },
    { backgroundColor: 'rgba( 36, 123, 188, 0.5)', borderColor: 'rgba( 36, 123, 188, 1.0)' },
    { backgroundColor: 'rgba(163, 206, 131, 0.5)', borderColor: 'rgba(163, 206, 131, 1.0)' }
];

export const TipoResposta = {
    'Sim/Não': 1,
    'Número': 2,
    'Texto': 3
};

export const Label = {
    pesquisar: 'Pesquisar',
    NC: 'Grau maior',
    AN: 'Grau menor',
    grafico: 'Gráfico',
    filtrar: 'Filtrar',
    grupo: 'Grupo',
    porQuem: 'Por quem',
    quando: 'Quando',
    acesso: 'Acesso',
    acoes: 'Ações',
    acaoTomada: 'Ação tomada',
    agendaAtividades: 'Agenda de Atividades',
    alterarFotoPerfil: 'Alterar Foto Perfil',
    alterarSenha: 'Alterar Senha',
    arquivo: 'Arquivo',
    arquivoNorma: 'Arquivo norma',
    norma: 'Norma',
    removerArquivo: 'remover arquivo',
    atencao: 'Atenção',
    ataReuniao: 'Ata de aprovação',
    ata: 'Ata',
    ativar: 'Ativar',
    ativo: 'Ativo',
    atualizarSenha: 'Atualizar senha',
    auditor: 'Auditor',
    auditoria: 'Auditoria',
    auditoriaFaseI: 'Auditoria Fase I',
    auditoriaFaseII: 'Auditoria Fase II',
    auditores: 'Auditores',
    auditoriasAndamento: 'Auditorias em Andamento',
    avaliacao: 'Avaliação',
    aprovacao: 'Aprovação',
    aprovacaoCadastro: 'Aprovação cadastro',
    bairro: 'Bairro',
    cadastroMantenedora: 'Cadastro de Mantenedora',
    cadastroSistemaGestao: 'Cadastro de Sistema de Gestão',
    cadastroUsuarios: 'Cadastro de Usuários',
    caixaEntrada: 'Caixa de Entrada',
    cancelar: 'Cancelar',
    cancelamento: 'Cancelamento',
    capacidadeInstalada: 'Capacidade Instalada',
    cargo: 'Cargo',
    cargoContato: 'Cargo Contato',
    cargoRepresentante: 'Cargo representante sistema',
    celular: 'Celular',
    CEP: 'CEP',
    certificacoes: 'Certificações',
    certificados: 'Certificados',
    certificadosVencer: 'Certificados a vencer (externo)',
    cidade: 'Cidade',
    clienteNum: 'Cliente #',
    clientes: 'Clientes',
    clicarArquivo: 'Clicar arquivo',
    CNPJ: 'CNPJ',
    configuracoes: 'Configurações',
    confirmarSenha: 'Confirmar senha',
    confirmeSenha: 'Confirme nova senha',
    contato1: 'Contato 1',
    contato2: 'Contato 2',
    contato3: 'Contato 3',
    contatos: 'Contatos',
    CPF: 'CPF',
    CPFCNPJ: 'CPF/CNPJ',
    descricao: 'Descrição',
    descricaoArquivo: 'Descrição do Arquivo',
    desenvolvimento: 'Desenvolvimento',
    desistencia: 'Desistência',
    detalhamento: 'Detalhamento',
    edicao: 'Edição',
    email: 'E-mail',
    emailContato: 'E-mail Contato',
    emailRepresentante: 'E-mail representante',
    emailRepresentanteSistema: 'E-mail representante sistema',
    empresa: 'Empresa',
    enquadramento: 'Enquadramento',
    entrar: 'Entrar',
    enviarCadastro: 'Enviar Cadastro',
    erro: 'Erro',
    esqueceuSenha: 'Esqueceu a senha?',
    estadoUF: 'Estado/UF',
    estrutura: 'Estrutura Organizacional',
    fechar: 'Fechar',
    filtro: 'Filtro',
    fornecedor: 'Fornecedor',
    fornecedores: 'Fornecedores',
    inativar: 'Inativar',
    inativo: 'Inativo',
    inscEstadual: 'Inscrição Estadual',
    inscMunicipal: 'Inscrição Municipal',
    instalacoes: 'Instalações',
    inicioProcesso: 'Início do processo',
    lista: 'Lista',
    localizacao: 'Localização',
    login: 'Login',
    logoEmpresa: 'Logo da Empresa',
    logradouro: 'Logradouro',
    mantenedora: 'Mantenedora',
    negocio: 'Negócio',
    nome: 'Nome',
    nomeContato: 'Nome Contato',
    nomeCliente: 'Nome Cliente',
    nomeRepresentante: 'Nome representante',
    nomeRepresentanteSistema: 'Nome representante sistema',
    nomeFantasia: 'Nome Fantasia',
    nomeMantenedora: 'Entre com o nome da mantenedora',
    nova: 'Nova',
    novaSenha: 'Nova senha',
    novo: 'Novo',
    novoAuditor: 'Novo Auditor!',
    novoFornecedor: 'Novo Fornecedor!',
    novoEscopoSolicitado: 'Novo escopo solicitado',
    numero: 'Número',
    numFuncionario: 'Número de funcionários',
    pagina404Titulo: 'Página 404',
    pagina500Titulo: 'Página 500',
    paginaLoginTitulo: 'Página de Login',
    paginaRegistroAuditorTitulo: 'Registro do Auditor',
    paginaRegistroFornecedorTitulo: 'Registro do Fornecedor',
    perfil: 'Perfil',
    possuoCertificacao: 'Possuo uma certificação ISO.',
    produtoServico: 'Produto / Serviço',
    quantidadeAvaliacoesDesenvolvimento: 'Quantidade de avaliações de Desenvolvimento',
    razaoSocial: 'Razão Social',
    reclamacao: 'Reclamação',
    reclamacaoApelacao: 'Reclamação e Apelação',
    registro: 'Registro',
    representantes: 'Representantes',
    reset: 'Reset',
    resultados: 'Resultados Financeiros',
    resultadosReuniaoCE: 'Resultados reunião CE',
    RG: 'RG',
    sair: 'Sair',
    salvar: 'Salvar',
    salvarReuniao: 'Salvar Reunião',
    segmento: 'Segmento',
    selecioneMantenedora: 'Selecione a mantenedora',
    selecionePerfil: 'Selecione o(s) perfil(s)',
    senha: 'Senha',
    setor: 'Setor',
    sigla: 'Sigla',
    site: 'Site',
    solicitacao: 'Solicitação',
    solicitarReset: 'Solicitar reset de Senha',
    status: 'Status',
    telefone: 'Telefone',
    telefone1: 'Telefone 1',
    telefone2: 'Telefone 2',
    telefones: 'Telefones',
    voltar: 'Voltar',

    edicaoPessoais: 'Edição de dados pessoais',
    perfisAtivos: 'Perfis ativos',

    deAcordo: 'De acordo fornecedor',
    deAcordo2: 'De acordo',

    documentoFornecedor: 'Documentos do Fornecedor',
    uploadDocumento: 'Upload de documentos',
    nomeArquivo: 'Nome do Arquivo',
    selecionarArquivo: 'Selecione o arquivo',
    selecionar: 'Selecionar',
    data: 'Data',
    dataUpload: 'Data de Upload',
    certificadosAuditor: 'Certificados Auditor',
    uploadDeDocumentosGerais: 'Upload de documentos gerais',
    parabens: 'Parabéns!',

    dadosPessoais: 'Dados Pessoais',
    anexarCertificado: 'Anexar certificado',
    anexarArquivo: 'Anexar arquivo',
    independente: 'Independente',
    sim: 'Sim',
    nao: 'Não',
    indicadoPor: 'Indicado por',
    formacao: 'Formação',
    cargaHoraria: 'Carga horária',
    entidade: 'Entidade',
    tipo: 'Tipo',
    tipoFormacaoAuditorInterno: 'Auditor Interno',
    tipoFormacaoLeadAssessor: 'Lead Assessor',
    tipoFormacaoGraduacao: 'Graduação',
    tipoFormacaoPosGraduacao: 'Pós-Graduação',
    tipoFormacaoMestrado: 'Mestrado',
    tipoFormacaoDoutorado: 'Doutorado',
    curso: 'Curso',
    experiencia: 'Experiência',
    atuacao: 'Atuação',
    espiritoSanto: 'Espírito Santo',

    fornInformacoesParaAuditoriaFase1: 'Fornecedor - Informações Para Auditoria Fase 1',
    UploadDocumentosFase1: 'Upload de Documentos e Formulários de Auditoria Fase I (Documental)',
    sistemaGestao: 'Sistema de Gestão',
    sistemaGestaoQualidadeFornecedor: 'Sistema de Gestão da Qualidade do Fornecedor',
    gtResultadoAuditoriaFase1: 'Revisor Técnico - Resultado de Auditoria de Certificação Fase I',
    fornResultadoAuditoriaCertificacaoFase1: 'Fornecedor - Resultado de Auditoria de Certificação Fase I',
    sistema: 'Sistema',
    contatoRepresentante: 'Contato representate',
    grupoDesenvolvimento: 'Grupo de desenvolvimento',
    alteracaoCadastro: 'Alteração de cadastro',
    dadosCadastro: 'Dados de cadastro',
    criarSolicitacao: 'Criar Solicitação',
    aprovarReprovar: 'Aprovar/Reprovar',
    candidata: 'Candidata',

    configurarAuditorias: 'Configurar Auditorias',
    fase1: 'Fase I',
    fase1Documental: 'Fase I (Documental)',
    fase2: 'Fase II',

    checkListAuditoriaFase2: 'Checklist Auditoria Fase II',
    numeroRequisito: 'Número do requisito',
    descricaoRequisito: 'Descrição do requisito',
    descricaoItemRequisito: 'Questões do item do requisito',
    itemRequisito: 'Questões do item requisito',
    requisitoSistemaGestao: 'Descrição do requisito do Sistema de Gestão',
    editarDescricaoRequisito: 'Editar descrição do requisito',
    numeroItemRequisito: 'Número e título do item do requisito',
    numeroTitulo: 'Número e título',
    questoes: 'Questões',
    criarItemRequisito: 'Criar Item',
    editarDescricaoNumeroRequisito: 'Editar Descrição e Número de Requisito',
    homologado: 'Homologado',
    qualificacao: 'Qualificação',
    homologadoQualificacao: 'Homologado / Qualificação',
    reprovar: 'Reprovar',
    aprovar: 'Aprovar',
    homologacao: 'Homologação',
    selecioneAuditores: 'Selecione os Auditores',
    selecioneAuditor: 'Selecione o Auditor',
    homologados: 'Homologados',
    periodoHomologacao: 'Período de homologação',
    de: 'De',
    ate: 'Até',
    dataDe: 'Data de',
    dataAte: 'Data até',
    conflitoInteresse: 'Conflito de Interesse',
    listaFornecedores: 'Lista dos Fornecedores',
    fornecedoresSelecionados: 'Fornecedores selecionados',
    sistemasGestao: 'Sistemas de Gestão do PRODFOR',
    edicaoDados: 'Edição de Dados',
    lider: 'Líder',
    segundoAuditor: 'Segundo Auditor',
    traine: 'Trainee',
    habilitadosAuditor: 'Habilitados para o auditor',
    removerConflito: 'Remover fornecedor do conflito de interesse',
    adicionarConflito: 'Adicionar fornecedor no conflito de interesse',
    removerHabilitacao: 'Remover item de habilitação do auditor',
    adicionarHabilitacao: 'Adicionar item de habilitação do auditor',
    observacoes: 'Observações',
    criarRequisito: 'Criar Requisito',
    uploads: 'Uploads',
    homologarAuditores: 'Homologar Auditores',
    avaliacoesDesenvolvimento: 'Avaliações de desenvolvimento - Entrar notas de avaliação',
    avaliacoesDesenvolvimentoNotas: 'Avaliações de desenvolvimento - notas de avaliação',
    registrarParecerDesenvolvimento: 'Registrar parecer de desenvolvimento',
    fornecedorSelecionado: 'Fornecedor selecionado',
    media: 'Média',
    parecer: 'Parecer',
    parecerGT: 'Parecer do Revisor Técnico',
    historicoParecer: 'Hitórico de parecer',
    finalizarAvaliacoes: 'Finalizar fase de avaliações',
    dados: 'Dados',
    processo: 'Processo',
    iniciado: 'Iniciado em',
    finalizado: 'Finalizado em',
    tarefaRealizar: 'Tarefa a Realizar',
    cadastroEm: 'Cadastro em',
    sucesso: 'Sucesso',
    ocorreuErro: 'Ocorreu um erro',
    relatorios: 'Relatórios',
    relatoriosGerais: 'Relatórios Gerais',
    relatorioMensal: 'Relatório Mensal',
    encontroTecnico: 'Encontro Técnico',
    cadastroListaPresenca: 'Cadastro da lista de presença',
    registroPresenca: 'Registro de Presença',
    dataEvento: 'Data do Evento',
    usuario: 'Usuário',
    tipoUsuario: 'Mantenedora, Fornecedor ou Independente',
    tipoEntidade: 'Entidade/Orgão/Empresa',
    listaParticipantes: 'Lista dos Participantes',
    presente: 'Presente?',
    imprimir: 'Imprimir',
    participante: 'Participante',
    documentosGerais: 'Documentos Gerais',
    uploadAtaReuniao: 'Upload da Ata da reunião',
    assuntosPauta: 'Assuntos da pauta',
    indicacao: 'Indicação',
    aprovadoPergunta: 'Aprovado?',
    tratadoPergunta: 'Tratado?',
    aceitarCertificado: 'Aceitar certificado?',
    APROVADO: 'APROVADO',
    mediaAvaliacao: 'Média avaliação',
    avaliacaoAprovada: 'Aprovado na avaliação?',
    analiseResultadoAuditoria: 'Análise do Resultado de Auditoria',
    tipoAuditoria: 'Tipo Auditoria',
    recomendacaoGt: 'Recomendação Revisor Técnico',
    ajustesNCs: 'Não conformidades',
    decisaoCE: 'Decisão CE',
    analiseAuditoriaCertificacao: 'Análise do Resultado de Auditoria - Certificação',
    certificado: 'Certificado',
    certificadoISO: 'Certificado ISO',
    emitidoPor: 'Emitido por',
    dataFechamentoRelatorio: 'Data de fechamento do relatório',
    dataExecucaoAud: 'Data de execução da auditoria',
    // dataDeAcordoAud: 'Data de execução da auditoria',
    solicitacaoFornecedorReclamacao: 'Solicitação Fornecedor - Reclamação',
    representante: 'Representante',
    parecerRetornoCE: 'Parecer do CE',
    parecerFinal: 'Parecer final da solicitação',
    parecerRetornoGT: 'Parecer do Revisor Técnico',
    solicitacaoFornecedorApelacao: 'Solicitação Fornecedor - Apelação',
    aprovarResultado: 'Aprovar Resultado?',
    solicitacaoFornecedorDesenvolvimento: 'Solicitação Fornecedor - Desenvolvimento em novo Sistema de Gestão',
    solicitacaoFornecedorCancelamentoCertificado: 'Solicitação Fornecedor - Cancelamento de Certificado',
    solicitacaoFornecedorDesenvolvimentoSistemaGestao: 'Selecione fornecedores cancelamento certificado',
    gerarPautaImpressa: 'Gerar pauta impressa',
    visualizarDadosFornecedor: 'Visualizar dados fornecedor',
    visualizarDadosCertificados: 'Visualizar dados certificado(s)',
    visualizarDocumentosFornecedor: 'Visualizar documentos fornecedor',
    dadosEmpresa: 'Dados da Empresa',
    enderecoEmpresa: 'Endereço da Empresa',
    contatoEmpresa: 'Contato da Empresa',
    representanteEmpresaSistema: 'Representante da Empresa no Sistema',
    setorTrabalho: 'Setor de Trabalho',
    visualizarDadosAuditor: 'Visualizar Dados Auditor',
    dadosAuditor: 'Dados auditor',
    estado: 'Estado',
    endereco: 'Endereço',
    registroDecisoes: 'Registro das decisões',
    itemPauta: 'Item da pauta',
    cadastroFornecedores: 'Cadastro de Fornecedores',
    certificacao: 'Certificação',
    certificacaoAnterior: 'Certificação anterior?',
    cadastro: 'Cadastro',
    cadastroAprovado: 'Cadastro Aprovado',
    cadastroReprovado: 'Cadastro Reprovado',
    filtroPor: 'Filtro por',
    todasColunas: 'Todas as colunas',
    retirarHomologados: 'Retirar homologados',
    adicionarHomologados: 'Adicionar homologados',
    itensPorPagina: 'Itens por página',
    anterior: 'Anterior',
    proximo: 'Próximo',
    primeiraPagina: 'Primeira página',
    ultimaPagina: 'Última Página',
    solicitacaoFornecedor: 'Solicitações do Fornecedor',
    novaSolicitacao: 'Nova Solicitação',
    nomeExibirSelectFornecedor: '(0) / Nome Fantasia: (1) - Mantenedora: (2)',
    nomeExibirSelectAuditor: '(0) / Indicação: (1) - Qualificações: (2)',
    nomeExibirSelectSolicitacao: '(0) / Nome Fantasia: (1) - Tipo da Solicitação: (2)',
    nomeExibirSelectCertificacao: '(0) / Nome Fantasia: (1) - Tipo da Auditoria: (2)',
    tituloCalendario: 'Calendário - Agenda de Atividades',
    ano: 'Ano',
    mes: 'Mês',
    hoje: 'Hoje',
    novasAtividades: 'Novas Atividades',
    reuniaoGT: 'Reunião Revisor Técnico',
    reuniaoCE: 'Reunião CE',
    reuniaoGrupoTecnico: 'Reunião Revisor Técnico',
    reuniaoComiteExecutivo: 'Reunião Comitê Executivo',
    auditoriaPrevista: 'Auditoria prevista',
    auditoriaProgramada: 'Auditoria programada',
    auditoriaCancelada: 'Auditoria cancelada',
    auditoriaAgendada: 'Auditoria confirmada',
    downloadAta: 'Download da ata da reunião',
    reuniaoCE_tituloDesenvolvimento: 'Desenvolvimento - Avaliação de Desempenho',
    reuniaoCE_tituloAcompanhamento: 'Desenvolvimento - Acompanhamento',
    reuniaoCE_tituloSolicitacao: 'Solicitações',
    visualizarDesenvolvimentoFornecedor: 'Visualizar Notas de Desenvolvimento do Fornecedor',
    parecerIEL: 'Parecer final do IEL',
    solicitacoes: 'Solicitações',
    alteracaoCadastral: 'Alteração Cadastral',
    desenvolvimentoNovoSistemaGestao: 'Desenvolvimento - Novo Sistema de Gestão',
    cancelamentoCertificado: 'Cancelamento de Certificado',
    desistenciaDesenvolvimento: 'Desistência de Desenvolvimento',
    processos: 'Processos',
    estacaoAtual: 'Estação Atual',
    processoFinalizado: 'Processo finalizado',
    processoEmAndamento: 'Processo em andamento',
    enviarFormularioPreenchido: 'Enviar formulário preenchido',
    unidadesEnvolvidas: 'Unidades envolvidas',
    faseIDocumentacao: 'Fase I (Documentação) - Download e Upload - ',
    formularioFornecedor: 'Formulário Fornecedor',
    analise: 'Análise',
    planoAcaoFornecedor: 'Plano de Ação Fornecedor',
    acompanhamentoFaseI: 'Acompanhamento resultado Fase I',
    planoAcao: 'Plano de Ação',
    unidade: 'Unidade',
    numFuncionarioSimples: 'Nº Funcionários',
    salvarAdicionar: 'Salvar/Adicionar',
    excluirEndereco: 'Excluir endereço',
    indicarAuditor: 'Indicar Auditor',
    analiseProdfor: 'Análise PRODFOR',
    pegarAnalise: 'Pegar para análise',
    // formularioFornecedor: 'Formulário Fornecedor',
    formularioEnviadoFornecedor: 'Formulário enviado pelo Fornecedor',
    formularioEnviado: 'Formulário enviado',
    nomeInformativoFormularioFornecedor: 'Formulário para Auditoria de Certificação Fase 1',
    dataEnvioFormulario: 'Data de envio do formulário',
    ok: 'OK',
    documentacaoFornecedor: 'Documentação do Fornecedor',
    documentacaoEnviadaFornecedor: 'Documentação enviada pelo Fornecedor',
    formularioEnvioPadrao: 'Formulário padrão de envio',
    resultadoAuditoriaFaseI: 'Resultado de Auditoria de Certificação Fase I',
    resultadoAuditoriaFaseIChecklistFornecedor: 'Checklist do fornecedor',
    retornoFormularioFornecedor: 'Retorno do Formulário Fornecedor',
    hitorico: 'Hitórico',
    documentoProdfor: 'Documento de análise do PRODFOR',
    enviadoEm: 'Enviado em',

    tipoSolicitacao: 'Tipo da Solicitação',
    visualizarDadosSolicitacoes: 'Visualizar Dados da Solicitacão',
    solicitacaoDescricaoFornecedor: 'Descrição da Solicitação',
    dataInicio: 'Data Início',
    dataFim: 'Data Fim',
    programacaoAuditoria: 'Programação de Auditoria',
    programacao: 'Programação',
    previsaoMesInicio: 'Previsão de execução (início)',
    previsaoMesFim: 'Previsão de execução (fim)',
    previsaoMes: 'Previsão de execução',
    selecionePrevisao: 'Selecione a previsão',
    primeiraQuinzena: '1ª Quinzena',
    segundaQuinzena: '2ª Quinzena',
    selecione: 'Selecione',
    zeroDeUm: '(0) de (1)',
    resumoHorasTecDes: '(0)h ((1)h técnicas e (2)h de deslocamento)',
    iniciarAuditoriaFaseII: 'Encaminhar para auditoria Fase II',
    equipeAuditoriaDetalhe: 'Auditor líder: (0)\nSegundo auditor: (1)\nTrainee: (2)',
    equipeAuditoriaDetalheHTML: '<strong>Auditor líder</strong>: (0)</br><strong>Segundo auditor</strong>: (1)</br><strong>Trainee</strong>: (2)',
    cargaHorariaDetalhesPrevisao: ' - CH previsão: _CH_',
    cargaHorariaDetalhesExectada: ' - CH executada: _CH_',
    quinzena: 'Quinzena',
    horas: 'horas',
    tecnicas: 'Técnicas',
    deslocamento: 'Deslocamento',
    diaExecucaoAuditoria: 'Dia de execução da auditoria',
    auditorLider: 'Auditor Líder',
    periodoExecucao: 'Período de execução',
    equipeAuditoriaLabel: 'Equipe técnica de auditores',
    equipeAuditores: 'Equipe de auditores',
    escopo: 'Escopo',
    escopoAntigo: 'Escopo antigo',
    novoEscopo: 'Alterar seu escopo',
    recomendacaoAuditoria: 'Recomendação para esta auditoria',
    escopoAuditoria: 'Escopo da auditoria',
    descricaoEscopoPlaceholder: 'Descrição das recomendações da auditoria',
    fornecedorAuditado: 'Fornecedor a ser auditado',
    dataAgendamentoAuditoria: 'Data de agendamento da auditoria',
    deAte: 'De > Até',
    marcarRequisitos: 'Marcar requisitos de auditoria',
    anoPrevisao: 'Ano da previsão',
    previsao: 'Previsão',
    dadosAuditoria: 'Dados da auditoria',

    solicitacaoAlteracaoCadastral: 'Solicitações de alteração cadastral',
    detalheSolicitacao: 'Detalhe Solicitação',
    dataSolicitacao: 'Data Solicitação',
    descricaoSolicitacao: 'Descrição da solicitação',
    retornoProdfor: 'Retorno do PRODFOR',
    camposAlteracaoSolicitacao: 'Campos de alteração da solicitação',
    registrarParecer: 'Registrar parecer',
    registroParecerSolicitacao: 'Registrar parecer da solicitação',
    registrarAprovacaoSolicitacao: 'Registrar aprovação/reprovação da solicitação',
    conforme: 'Conforme',
    naoConforme: 'Não conforme',
    ajuste: 'Ajuste',
    ajustes: 'Ajustes',
    filtroPorTipo: 'Filtro por tipo',
    finalizar: 'Finalizar',

    dataExecucaoAuditoria: 'Data de realização da auditoria',
    finalizarAuditoria: 'Finalizar auditoria',
    fecharRelatorioAuditoria: 'Fechar relatório de auditoria',
    visualizarRelatorioAuditoria: 'Visualizar relatório de auditoria',
    registrarRecomendacoes: 'Registrar recomendações',
    aprovarCertificacao: 'Aprovar certificação',
    aprovarRecertificacao: 'Aprovar recertificação',
    aprovarManutencao: 'Aprovar manutenção',
    recomendarCertificacao: 'Recomendar certificação',
    recomendarRecertificacao: 'Recomendar recertificação',
    recomendarManutencao: 'Recomendar manutenção',
    canSuspCertificado: 'Cancelar/Suspender certificação',
    verificarChecklistAuditoria: 'Verificar checklist de auditoria',
    baixarPlanilha: 'Baixar planilha',
    carregarPlanilha: 'Carregar planilha',
    arquivoEvidencia: 'Arquivo evidência',
    arquivoPlanoAcao: 'Arquivo plano de ação',
    evidenciasApontamentos: 'Evidências analisadas e/ou apontamentos',
    relatorioEnvio: 'Relatório enviado por',
    recomendacoesAuditoria: 'Recomendações para a auditoria',
    registreRecomendacoesAuditoria: 'Registre suas recomentações para essa auditoria',
    recomendacoesCertificacao: 'Recomendações para a certificação',
    registreRecomendacoesCertificacao: 'Registre suas recomentações para certificação desse fornecedor',
    evidencias: 'Evidências',
    causasProvaveis: 'Causas prováveis',
    tooltipCausasProvavavies: 'Descreva as causas prováveis',
    acoesCorretivas: 'Ações Corretivas',
    tooltipAcoesCorretivas: 'Descreva as ações corretivas',
    prazos: 'Prazos',
    tooltipPrazos: 'Digite os prazos',
    responsavel: 'Responsável',
    tooltipResponsavel: 'Nome dos responsáveis',
    enviarArquivo: 'Caso necessário, envie um arquivo',
    deletarArquivoPlano: 'Deletar arquivo do plano de ação',
    deletarArquivoEvidencia: 'Deletar arquivo de evidência',
    apelacao: 'Apelação',
    carregarPlanilhaAuditoria: 'Carregar planilha de auditoria',
    planilhaChecklist: 'Planilha de checklist',
    auditoriaPresencial: 'Auditoria Presencial',
    checklist: 'Checklist',
    planoAcaoAuditoriaPresencial: 'Plano de Ação da Auditoria Presencial',
    resumoAuditoria: 'Resumo da auditoria',
    naoConformidades: 'Não conformidades',
    areaInteresse: 'Área de interesse',

    solicitacaoDesistencia: 'Descrição da solicitação',
    sistemaGestaoSelecionado: 'Sistema de gestão selecionado',
    solicitacaoDesenvolvimentoSistemaGestao: 'Solicitações de desenvolvimento de sistema de gestão',
    solicitacaoApelacao: 'Solicitações de apelação',
    auditoriaSelecionada: 'Auditoria selecionada',
    solicitacaoCancelamento: 'Solicitações de cancelamento',
    motivoCancelamento: 'Motivo do cancelamento',
    motivoSelecionado: 'Motivo selecionado',
    reclamacoesGerais: 'Reclamações gerais',
    qtdMaxNotasDesenvolvimentos: 'Qtd máxima de notas',
    salvarParecer: 'Salvar Parecer',
    dataProgramacao: 'Data/Programação',
    detalhes: 'Detalhes',
    somenteProcessosAbertos: 'Somente processos abertos',
    declaracaoAuditor: 'Declaração Auditor',
    registrarPagamentos: 'Registrar pagamentos',
    suspenderTemporariamente: 'Suspender temporariamente',
    checklistFaseII: 'Checklist Fase II',
    cargaHorariaTecDesloc: 'Carga horária (técnica/deslocamento)',
    financeiro: 'Financeiro',
    custoAuditoria: 'Custo Auditoria',
    agendamento: 'Agendamento',
    auditoriaSuspensa: 'Auditoria Suspensa',
    auditoriaFinalizada: 'Auditoria Finalizada',
    registrarDecisao: 'Registrar Decisão',
    auditoriaExecutada: 'Auditoria executada',
    adicionarItem: 'Adicionar item',
    removerItem: 'Remover item',
    remover: 'Remover',
    editarUsuarioComo: 'Editar usuário como',
    perfilInterno: 'Perfil interno',
    logarComo: 'Deseja se logar como',
    confirma: 'Confirma?',
    cadastros: 'Cadastros',
    avaliacaoAuditor: 'Avaliação Auditor',
    homolocaoAuditores: 'Homologação de Auditores',
    auditorias: 'Auditorias',
    auditoriaFaseIIProgracao: 'Auditoria Fase II - Programação e Agendamento',
    usuarios: 'Usuários',
    mantenedoras: 'Mantenedoras',
    pesquisaSatisfacao: 'Pesquisa de Satisfação',
    analisePesqSatisfacao: 'Análise da Pesquisa de Satisfacao',
    analiseCertificadoExternoISO: 'Análise Certificação ISO',
    checklistAuditoriaFaseII: 'Checklist de Auditoria Fase II',
    enviarAnalise: 'Enviar para análise',
    exibirDetalhamentoNotasLado: 'Clique para exibir o detalhamento das notas',
    analiseGT: 'Análise Revisor Técnico',
    analiseCE: 'Decisão do Comitê Executivo',
    dataRelatorioFechado: 'Relatório fechado em',
    resumoDetalhes: 'Não conformidades: Grau menor: (1)\nGrau maior: (0)',
    agendarAcompanhamento: 'Agendar acompanhamento',
    agendarExtraordinaria: 'Agendar extraordinária',
    agendarAcompanhamentoExtraordinaria: 'Agendar acomp./extra.',
    voceSelecionou: 'Você selecionou',
    parecerAnaliseAuditoria: 'Parecer de análise do auditor',
    alterarNaoConformidade: 'Alterar conformidade',
    emitirCertificado: 'Emitir certificado',
    cancelarCerttificado: 'Cancelar certificado',
    numeroCertificadoProdFor: 'Número do certificado no PRODFOR',
    numeroCertificado: 'Número certificado',
    fecharRelatorioPlanoAcao: 'Fechar plano de ação auditoria',
    aprovarPlanoAcaoFornecedor: 'Validar plano de ação fornecedor',
    quem: 'Quem',
    acaoExecutada: 'Ação executada',
    estacao: 'Estação',
    cadastroNaoAnalisado: 'Dados do cadastro do auditor não analisado',
    alterarProgramacao: 'Alterar programação',
    alterarEquipeAuditoria: 'Alterar equipe de auditoria',
    auditoriaPeriodoDeExecucao: 'Auditoria em período de execução',
    auditoriaEmAtraso: 'Auditoria com execução em atraso ou relatório não finalizado',
    detalhesCertificado: 'Detalhes do certificado',
    gerarNovoNumero: 'Editar número certificado',
    criarNovoNumero: 'Gerar número certificado',
    manterNumeroCertificado: 'Manter número do certificado',
    registrarObservacaoCertificacao: 'Registre as observações para certificação',
    registreObservacaoCertificacaoTootip: 'Registre suas observações para a certificação desse fornecedor',

    somenteCertificadosValidos: 'Somente certificados em dia',
    anoCertificacao: 'Ano de Certificação',
    statusCertificado: 'Status Certificado',
    editarReuniao: 'Editar reunião',
    finalizarReuniao: 'Finalizar edição',

    pergunta: 'Pergunta',
    TipoResposta: 'Tipo da Resposta',
    novaPergunta: 'Adicionar Nova Pergunta',
    editarPergunta: 'Editar Pergunta',
    procede: 'Procede',
    naoProcede: 'Não Procede',

    TipoResSimNao: 'Sim/Não',
    TipoResNumero: 'Número de 1 a 4',
    TipoResTexto: 'Texto',
    certificadoNumero: 'Certificado #',
    analiseAuditoria: 'Análise auditoria',
    gt: 'Revisor Técnico',
    enviarDocumento: 'Enviar documento',
    imprimirCertificado: 'Imprimir certificado',
    reativar: 'Reativar',
    reativarCertificado: 'Reativar certificado',
    suspenderCertificado: 'Suspender certificado',
    cancelarCertificado: 'Cancelar certificado',
    unidadesEnvolvidasCertificado: 'Unidades envolvidas no certificado',
    situacao: 'Situação',
    validade: 'Validade',
    validadoAte: 'Válido até',
    anoPrimeiraCertificacao: 'Ano da 1ª certificação',
    hitoricoCertificado: 'Hitórico do Certificado',
    dataEmissao: 'Data emissão',
    cadastroPerguntas: 'Cadastro de perguntas',
    respostaQuestionario: 'Resposta ao questionário',
    analiseQuestionario: 'Respostas do fornecedor ao questionário',
    enviar: 'Enviar',
    gerarRelatorio: 'Gerar relatório',
    pdf: 'PDF',
    excel: 'ExcelCSV',
    auditoriaPorTipo: 'Auditoria por Tipo',
    numerosProdfor: 'Números do PRODFOR',
    auditoriaPorSistemaGestao: 'Auditoria por Sistema Gestão',
    graficoSolicitacao: 'Gráfico de solicitações',
    graficoTipoAuditoria: 'Gráfico de auditorias por tipo de auditoria',
    graficoTipoSistemaGestao: 'Gráfico de auditorias por sistema de gestão',
    graficoTipoCertificacao: 'Gráfico de status de certificado por sistema de gestão',
    graficoResultadoCertificacao: 'Gráfico de aprovações do CE por tipo de resultado',
    graficoPesquisaSatisfacao: 'Gráfico pesquisa de satisfação',
    filtrosRelatorios: ' Filtros para o relatório',
    visualizarAuditoriaAnterior: 'Visualizar auditoria anterior',
    programarNovaAuditoria: 'Programar nova auditoria',
    iniciarProcessoCertificacao: 'Iniciar novo processo de certificação',
    estacaoInicial: 'Estação inicial',

    escopoCertificacao: 'Escopo de certificação do Sistema de Gestão',
    registroParecerAuditoria: 'Registro de comentário',
    auditoriaAnterior: 'Auditoria anterior',

    alterarAnalista: 'Alterar auditor analista',
    analisarItem: 'Analisar item / Tomar ação',
    visualizarItem: 'Visualizar item',
    deacordo: 'De acordo',
    relatorioAuditoria: 'Relatório de auditorias',
    // auditoriaAnterior: 'Auditoria anterior',
    editarUsuario: 'Editar usuário',
    editarFornecedor: 'Editar fornecedor',
    editarAuditor: 'Editar auditor',
    visualizarSolicitacao: 'Visualizar solicitação',
    editarSolicitacao: 'Editar solicitação',
    encaminharIEL: 'Encaminhar ao IEL',
    encaminharGT: 'Encaminhar ao Revisor Técnico',
    EncaminharCE: 'Encaminhar a secretaria',
    execucaoAuditoria: 'Execução auditoria',
    parecerAuditoria: 'Comentário do Auditor líder',
    parecerReprovacaoPlanoAcao: 'Comentário do Auditor líder - plano de ação reprovado',
    salvarRascunho: 'Salvar o rascunho',
    finalizarRelatorio: 'Salvar e finalizar o relatório',
    validacaoPlanoFornecedor: 'Validar plano de ação fornecedor',
    validacaoItensConstatacaoAuditoria: 'Validação do registro de constatação de auditoria',
    // retonarFornecedor: 'Retornar ao fornecedor',
    NCgrauMaior: 'Grau maior',
    naoConcordo: 'Não concordo',
    encaminharAuditoria: 'Encaminhar para auditoria',
    confirmarAuditoria: 'Confirmar auditoria',
    validarConstatacoes: 'Validar constatações da auditoria',
    naoConcordoConstatacaoes: 'Não concordo com as constatações da auditoria',
    solicitarEscopo: 'Solicitar alteração no escopo',
    alteracaoEscopo: 'Alteração do Escopo',
    comentarioAuditor: 'Comentário final do auditor líder',
    constatacao: 'Constatação',
    pautaReuniao: 'Pauta Reunião',
    solicitacoesFornecedor: 'Solicitações do Fornecedor',
    avaliacoesDesempenho: 'Avaliações de desempenho',
    cadastroAuditores: 'Cadastro de Auditores',
    acompanhamentoDesenvolvimento: 'Acompanhamento de desenvolvimento',
    constatacaoRegistrada: 'Constatação registrada',
    descricaoProblemas: 'Descrição do problema/Fato/Constatação',
    iniciarProcessoAuditoria: 'Iniciar Processo de Auditoria',
    orgaoEmissor: 'Orgão emissor',
    reuniaoCEAnalise: 'Análise reunião CE',
    reuniaoGTAnalise: 'Análise reunião Revisor Técnico',
    comentariosSalvos: 'Comentários salvos',
    recomendacoes: 'Recomendações',
    requisitosNaoAtendidos: 'Requisitos não atendidos',
    evidenciasProblema: 'Evidências não conformidade',
    tipoGrafico: 'Tipo de gráfico',
    todos: 'Todos',
    semGrupoDefinido: 'Sem grupo de desenvolvimento definido',
    acumuladoPorAno: 'Acumulado por ano',
    filtroAte: 'Filtro usado: (0) até (1)',
    filtroUsado: 'Filtro usado: ',
    acumulado: 'Acumulado',
    filtros: 'Filtros',
    tipos: 'Tipos',
    relatorioPendencias: 'Relatório de pendências',
    itensTotal: 'Total de itens',
    baixarPlanilhaItens: 'Baixar planilha com os itens preenchidos',
    baixar: 'Baixar',
    exportarCSV: 'Exportar CSV',
    exportarPDF: 'Exportar PDF',
    dataCadastro: 'Data cadastro',
    periodoData: 'Período/Data agendamento auditoria',
    dataRealizacao: 'Data realização auditoria',
    nomeFornecedor: 'Nome do fornecedor',
    estimada: 'Estimada',
    executada: 'Executada',
    prevista: 'Prevista',
    salvarCargaHoraria: 'Salvar carga horária',
    total: 'Total',
    periodo: 'Período',
    declaracaoAuditorias: 'Declaração de Auditorias',
    todas: 'Todas',
    pagamentoRecebimento: 'Pagamento/recebimento',
    auditorNaoDefinido: 'Auditor não definido',
    previstasNaoProgramadas: 'Previstas não programadas',
    programadasNaoAgendadas: 'Programadas não agendadas',
    pendenciaCom: 'Pendência com',
    auditoriaFinalizadaEm: 'Auditoria finalizada em',
    diasEmAtraso: 'Dias em atraso',
    previstaParaMeses: 'Entre os meses de',
    pagamentoEfetuado: 'Pagamento efetuado ao auditor',
    pagamentoRecebido: 'Pagamento recebido do fornecedor',
    salvarArquivo: 'Salvar arquivo',
    aceitar: 'Aceitar',
    rejeitar: 'Rejeitar',
    ajustarCertificado: 'Ajustar dados certificado',
    certificadoAtualizado: 'Certificado atualizado com sucesso',
    infoGrupoCertificacaoUpdate: 'Informações do grupo e ano de certificação atualizadas',
    auditoriasRealizadas: 'Auditorias realizadas',
    auditoriasAgendadas: 'Auditorias agendadas',
    auditoriasProgramadas: 'Auditorias programadas',
    dataAbertura: 'Aberta em',
    grauMaior: 'Grau maior',
    grauMenor: 'Grau menor',
    emissaoeValidade: 'Emitido em (0), válido até (1)',
    informacoesNovoCertificado: 'Entre com as informações do novo certificado',
    resumo: 'Resumo',
    copiarEscopoAnterior: 'Copiar escopo anterior',
    observacoesFase2: 'Observações para Fase II',
    tratadaAvaliacao: 'Tratada na avaliação?',
    aprovadoAvaliacao: 'Aprovado nas avaliação?',
    recomendacoesRT: 'Recomendações\nRevisor Técnico',
    ultimaNota: 'Útima nota',
    totalCancelamentos: 'Total de cancelamentos',
    cancelamentos: 'Cancelamentos',
    quantidadeAuditorias: 'Quantidade de auditorias',
    fornecedoresDesenvolvimento: 'Fornecedores em desenvolvimento',
    quantidade: 'Quantidade',
    certificadosValidos: 'Certificados válidos',
    apelacoesReclamacoes: 'Apelações e reclamações',
    totalAuditoriasRealizadas: 'Total de auditorias realizadas',
    quantidadeCertificados: 'Quantidade de certificados',
    auditoriasSeremRealizadas: 'Auditorias a serem realizadas',
    quantidadeCertificadosValidos: 'Quantidade de certificados validos',
    quantidadePlanoAcaoVencer: 'Quantidade de planos de ação a vencer',
    quantidadeFornecedoresSetor: 'Quantidade de fornecedor por setor',
    municipio: 'Município',
    concordoTermoDeUso: 'Concordo',
};


export const Mensagem = {
    fornecedorNaoEncontrado: 'Fornecedor não encontrado',
    auditorNaoEncontrado: 'Auditor não encontrado',
    arquivoRemovido: 'Arquivo removido com sucesso',
    ordemAtualizada: 'Ordem atualizada com sucesso',
    falhaAtualizarOrdem: 'Falha ao atualizar ordem',
    requisitoCadastrado: 'Requisito cadastrado com sucesso',
    requisitoNaoEncontrado: 'Requisito não encontrado',
    itemRequisitoNaoEncontrado: 'Item do requisito não encontrado',
    itemRequisitoCadastrado: 'Item do requisito cadastrado com sucesso',
    novoCertificadoCriado: 'Novo certificado criado!',
    falhaAtualizarWorkflow: 'Falha ao atualizar workflow',
    falhaAnalisarPesquisa: 'Falha ao analisar pesquisa de satisfação',
    acaoNaoEncontrada: 'Ação não encontrada',
    perguntaNaoEncontrada: 'Pergunta não encontrada',
    registroNaoEncontrado: 'Registro não encontrado',
    falhaRecuperarListaPergunta: 'Falha ao recuperar lista de perguntas',
    falhaRecuperarAcoes: 'Falha ao recuperar ações',
    semPontosTracos: 'Sem pontos ou traços',
    erroAoGerarNumeroCertificado: 'Erro ao gerar número de certificado',
    selecionarAuditoriaApelacao: 'Favor selecionar uma auditoria',
    falhaGeralLogin: 'Falha ao processar sua requisição de login. Por favor, verifique o login e senha digitados e tente novamente.',
    emailResetSenhaEnviado: 'Enviamos um email para seu usuário cadastrado, com instruções para recriar sua senha de acesso!',
    falhaEnvioMensagemEmail: 'Falha ao gerar email para recuperação de senha. Favor tentar mais tarde!',
    registrarPagamentosAuditoria: 'Registrar pagamentos da auditoria',
    descricaoAlteracaoAuditoria: 'Descreva aqui sua solicitação de alteração, caso necessite.',
    tituloModalPagamentosAuditoria: 'Por favor, informe os custos da auditoria e marque se foram feitos os pagamentos aos auditores ou se o fornecedor efetuou o pagamento.',
    monteEquipeAuditoria: 'Monte a equipe para auditoria.',
    selecioneAuditor: 'Selecione um auditor da equipe',
    cargaHorariaTecDesloc: 'Carga Horária (horas)',
    encontradaNaoConformidades: 'Foram encontradas não conformidades?',
    acessoSistema: 'Entre com seus dados de acesso',
    alterarSenhaAcesso: 'Alteração de Senha de Acesso',
    cadastroFornecedorSubTitulo: 'Por favor, preencha as informações solicitadas para enviar sua solicitação de cadastro.',
    cadastroFornecedorTitulo: 'Cadastro de Fornecedores',
    cadastroNovoAuditor: 'Se você deseja ser um auditor do PRODFOR, solicite aqui seu cadastro.',
    cadastroNovoFornecedor: 'Se você deseja ser um fornecedor do PRODFOR, solicite aqui seu cadastro.',
    CEPTooltip: 'Entre com o CEP para consultarmos as demais informações',
    certificacoesTexto: 'Por favor, nos informe agora se você já possui alguma certificação em Sistema de Gestão da Qualidade expedida por outro orgão competente.',
    clienteTexto: 'Por favor, nos informe agora 3 de seus principais clientes.',
    consultaDadosReceita: 'Entre com o CNPJ de sua empresa, para consultar seus dados junto à Receita Federal',
    contatoTexto: 'Por favor, nos informe agora três contatos em sua empresa.',
    CPF_CNPJ_invalido: 'CPF ou CNPJ inválido!',
    CPFInvalido: 'O campo CPF está inválido',
    CPFObrigatorio: 'O campo CPF é obrigatório',
    escopoCertificacaoObrigatorio: 'O campo Escopo de certificação é obrigatório',
    dataEmissaoCertificacaoObrigatorio: 'O campo Data Emissão é obrigatório',
    dataValidadeCertificacaoObrigatorio: 'O campo Validade é obrigatório',
    emitidoPorCertificacaoObrigatorio: 'O campo Emitido por é obrigatório',
    situacaoCertificacaoObrigatorio: 'O campo Situação é obrigatório',
    detalhamentoTooltip: 'Detalhes do produto ou serviço',
    emailObrigatorioInvalido: 'O campo e-mail é obrigatório ou, se preenchido, está em um formato inválido',
    endereco: 'Avenida Nossa Senhora da Penha, 2053/2º andar, Ed. Findes - Santa Luíza, Vitória - ES, 29045-402',
    entrarLoginAcesso: 'Favor entrar com seu login de acesso!',
    estadoTooltip: 'Atualmente estamos aceitando apenas cadastros de empresas do Estado do Espírito Santo. Obrigado pela compreensão!',
    estruturaTooltip: 'Descrição da estrutura, principais níveis hierárquicos',
    falhaLogin: 'Falha no login',
    falhaRecuperarNotasFornecedor: 'Falha ao recuperar as notas de avaliação do fornecedor',
    falhaRecuperarListaArquivos: 'Falha ao recuperar lista de arquivos',
    falhaRecuperarListaPerfil: 'Falha ao recuperar lista dos perfis',
    falhaRecuperarListaUsuario: 'Falha ao recuperar lista com usuários',
    falhaRecuperarListaFornecedores: 'Falha ao recuperar lista dos Fornecedores',
    falhaRecuperarInfoCertificado: 'Falha ao recuperar informações do Certificado',
    falhaRecuperarListaAuditores: 'Falha ao recuperar lista dos Auditores',
    falhaRecuperarListaAuditorias: 'Falha ao recuperar lista de Auditorias',
    falhaRecuperarInfoUsuario: 'Falha ao recuperar informações do usuários selecionado para edição',
    falhaRecuperarInfoFornecedor: 'Falha ao recuperar informações do fornecedor para edição',
    falhaRecuperarMantenedora: 'Falha ao recuperar os dados das mantenedoras do sistema',
    falhaRecuperarUsuario: 'Falha ao recuperar dados do usuário selecionado',
    falhaRecuperarSetor: 'Falha ao recuperar dados do setor, favor entrar em contato com o PRODFOR',
    falhaRecuperarSegmento: 'Falha ao recuperar dados de segmento, favor entrar em contato com o PRODFOR',
    falhaRecuperarEnquadramento: 'Falha ao recuperar dados de enquadramento, favor entrar em contato com o PRODFOR',
    falhaRecuperarTipoAuditoria: 'Falha ao recuperar os tipos de auditorias',
    falhaRecuperarInfoSolicitacoes: 'Falha ao recuperar Informações da Solicitação',
    falhaRealizarUploadFoto: 'Falha ao realizar upload da foto do usuário',
    falhaUpload: 'Falha ao realizar upload de arquivo',
    falhaSalvar: 'Erro ao salvar dados no banco: ',
    falhaConexaoInternet: 'Falha na conexão com o servidor, verifique sua conexão com a internet. ',
    observacaoSolicitacaoAlteracaoCadastro: 'Observação na Alteração de cadastro, há uma solicitação em andamento',
    instalacoesTooltip: 'Ex: Infraestrutura, Capacidade, Sede própria, Etc',
    localizacaoTexto: 'Por favor, nos informe agora onde fica sua empresa.',
    mantenedoraObrigatorio: 'Favor selecionar a mantenedora que o usuário está ligado',
    tituloRelatorioPendencias: 'Por favor, selecione o tipo de pendência para gerar seu relatório',
    mantenedoraSalvar: 'Mantenedora salva com sucesso',
    mesmoRepresentante: 'Marque aqui caso seja a mesma pessoa do item acima.',
    negocioTexto: 'Por favor, nos informe agora sobre os produtos e serviços de sua empresa.',
    nomeObrigatorio: 'O campo Descrição do requisito é obrigatório',
    numeroObrigatorio: 'O campo Número do requisito é obrigatório',
    perfilInvalido: 'Ao menos um perfil deve ser selecionado',
    representanteSistemaTexto: 'Por favor, nos informe agora os dados da pessoa que será responsável pelo sistema de gestão da empresa em nosso sistema.',
    representantesTexto: 'Por favor, nos informe agora o representante legal que assina pela empresa.',
    resetSenha: 'Entre com seu login de acesso para solicitar o reset de senha',
    resultadosTooltip: 'Faturamento nos dois últimos anos',
    retornarLoginTooltip: 'Retornar à tela de login!',
    selecioneEnquadramento: 'Selecione o enquadramento',
    selecioneSegmento: 'Selecione o segmento de sua empresa',
    selecioneSetor: 'Selecione o setor de sua empresa',
    selecioneGrupo: 'Selecione o grupo de desenvolvimento',
    selecioneAnoCertificacao: 'Selecione ano certificação',
    senhaAlterada: 'Senha alterada com sucesso!',
    senhasIguais: 'As senhas devem ser iguais!',
    site: 'www.prodfor.com.br',
    sitePrograma: 'Site do Programa:',
    tabEmpresaSubTitulo: 'Por favor, nos informe os dados de sua empresa.',
    usuarioSalvar: 'Usuário salvo com sucesso.',
    validarCampo: 'Favor validar!',
    validarSenha: 'ATENÇÃO! A sua senha deve conter pelo menos: \n - 1 letra maiúscula; \n - 1 letra minúscula; \n - 6 caracteres',

    situacaoEmpresaInativa: 'O CNPJ informado, _CNPJ_, não consta como ativo na Receita Federal. Favor verificar!',
    cadastroFornecedorSucesso: 'Seu cadastro foi enviado ao PRODFOR com sucesso! Em breve você receberá um e-mail com instruções de acesso ao sistema.',

    uploadFornecedor: 'Faça aqui o upload dos documentos pertinentes à sua empresa. Políticas de qualidade, certificados, logotipo, mapa de processos e outros.',
    uploadCertificado: 'Caro Auditor, faça aqui o upload de seus certificados de auditorias.',

    cadastroAuditoresTitulo: 'Cadastro de Auditores',
    cadastroAuditoresSubTitulo: 'Por favor, preencha as informações solicitadas para enviar sua candidatura.',
    subTituloTabDadosPessoais: 'Por favor, nos informe seus dados pessoais.',
    estadoAuditorTooltip: 'Atualmente estamos aceitando apenas cadastros de auditores do Estado do Espírito Santo. Obrigado pela compreensão!',
    subTituloTabFormacao: 'Por favor, nos informe agora sua formação como auditor e acadêmica.',
    sobreCurso: 'Descreva sobre o curso',
    subTituloExperiencias1: 'Por favor, nos informe agora sobre suas experiências em auditorias.',
    subTituloExperiencias2: 'Em atuação, indicar se foi como líder, 2º auditor ou acompanhante.',
    toolTipAtuacao: 'Detalhes da atuação como auditor',

    clicarArquivo: 'Clique para selecionar',
    arquivoObrigatorio: 'Favor selecionar o arquivo',
    fornecedorObrigatorio: 'Favor selecionar um fornecedor',
    auditorObrigatorio: 'Favor selecionar um auditor',
    arquivoAtaObrigatorio: 'Favor selecionar a ata da reunião',
    SelecionarArquivo: 'Selecione o arquivo e clique no ícone de Upload ao lado.',
    descricaoArquivoObrigatorio: 'Favor colocar a descrição do arquivo',
    arquivoSalvar: 'Arquivo salvo com sucesso.',
    auditoresHomologadosSucesso: 'Auditores homologados com sucesso',
    auditoresHomologadosErro: 'Falha ao homologar auditores',

    cnpjJaCadastrado: 'O CNPJ informado já está cadastrado no PRODFOR. Favor entrar em contato com a secretaria para verificar!',
    cpfJaCadastrado: 'O CPF informado já está cadastrado no PRODFOR. Favor entrar em contato com a secretaria para verificar!',

    cnpjObrigatorio: 'Favor entrar com o CNPJ da empresa!',
    cnpjInvalido: 'CNPJ inválido!',
    selecionarAuditorHomologar: 'Favor selecionar o(s) auditor(es) a ser(em) homologado(s)',
    selecionarSistemaGestaoInicial: 'Selecione o Sistema de Gestão incial',
    selecionarDatasHomologacao: 'Por favor, selecione as datas de início e fim de homologação para adicionar os auditores na lista de homologados.',
    selecionarSegmento: 'Favor selecionar o segmento!',
    selecionarSetor: 'Favor selecionar o setor!',
    selecionarEnquadramento: 'Favor selecionar o enquadramento!',
    emailFormatoInvalido: 'E-mail em formato inválido!',
    campoObrigatorio: 'O campo _CAMPO_ é obrigatório.',
    cepIncorreto: 'O CEP informado está incorreto',
    falhaValidacaoCEP: 'Não foi possível verificar o CEP informado.',
    descricaoCertificadoAuditor: 'Certificado de formação. Auditor: _NOME_',
    auditorCadastroSucesso: 'Seu cadastro foi enviado ao PRODFOR com sucesso! Nossa equipe irá analisar seus dados e em breve entraremos em contato com as instruções de acesso ao sistema.',
    campoVermelhoObrigatorios: '* os campos destacados em vermelho são de preenchimento obrigatório',
    todosCamposObrigatorios: 'Todos os campos são obrigatórios',

    FacaUploadDocumentosFase1: 'Faça o upload dos documentos abaixo para que seu sistema de gestão fique configurado e os documentos possam ser utilizados pelos fornecedores e gestores técnicos.',
    siglaObrigatoria: 'Favor entrar com a Sigla do Sistema de Gestão!',
    qtdAvaliacoesObrigatória: 'Favor entrar com a quantidade de avaliações',

    sistemaGestaoSalvar: 'Sistema de Gestão salvo com sucesso',
    sistemaGestaoFase01Salvar: 'Arquivos Salvos com sucesso',
    alterarArquivo: 'Faça a alteração de pelo menos um Arquivo',
    sistemaGestaoArquivoRemover: 'Arquivo removido com sucesso',
    falhaRemoverArquivo: 'Falha ao remover arquivo',

    aprovacaoCadastroFornecedor: 'Caro usuário Secretaria PRODFOR, por favor verifique os dados do fornecedor para aprovação.',
    alteracaoCadastroFornecedor: 'Caro usuário Secretaria PRODFOR, toda alteração no cadastro do Fornecedor é controlada e será gerado um registro de alteração dos dados.',
    dadosFornecedorMsg1: 'Olá Fornecedor, a alteração dos dado em seu cadastro, pertinentes ao Certificado, após aprovado, é controlada e deve ser aprovada pelo PRODFOR.',
    dadosFornecedorMsg2: 'Após atualizar seus dados, clique no botão "Salvar". Caso dentre as alterações contiver dados sensíveis ao Certificado, será apresentada uma caixa de texto para criarmos uma solicitação de alteração cadastral que será levada ao Comitê Executivo para verificação e aprovação.',
    dadosFornecedorMsg3: 'Acompanhe sua solicitação no menu "Solicitações"',
    dadosAtualizadosSucesso: 'Seus dados foram atualizados com sucesso',

    insiraNumero: 'Insira o número identificador do requisito',
    insiraRequisito: 'Insira a descrição do requisito',
    insiraNumeroItem: `Insira o número e a descrição do Item do Requisito. Havendo mais de um, inserir um por linha. Ex:\n1.1 - Título1\n1.1.1 - Título2`,
    insiraRequisitoItem: 'Insira as questões para verificação do atendimento aos requisitos',
    listaRequisito: 'Lista com os requisitos (clique no icone das setas e araste para ordenar a lista).',
    listaRequisitoAdicionar: 'Preencha os campos acima e clique no botão "Criar Requisito", para adicionar os requisitos.',

    subTituloAuditorConflito: 'Por favor, selecione os Fornecedores com conflito de interesse com esse auditor.',
    subTituloAuditorAtuacao1: 'Por favor, selecione os Sistemas de Gestão e qualificação que esse auditor está habilitado em atuar.',
    subTituloAuditorAtuacao2: 'Ainda é necessário homologar o mesmo para cada Sistema de Gestão.',
    subTituloAuditorAtuacao: 'Por favor, selecione as áres de interece para atuação como auditor',

    tituloAuditorEditarDados: 'Auditor, mantenha os dados de seu cadastro sempre atualizados.',
    tituloAuditorEditarDadosAprovacao: 'Verifique os dados do auditor para aprovação de seu cadastro.',
    selecionarFornecedor: 'Favor selecionar o(s) fornecedores para essa ação',
    selecionarSistemaGestao: 'Favor selecionar o Sistema de Gestão para adicionar como habilitado',
    selecionarQualificacao: 'Favor selecionar a qualificação para adicionar como habilitado',
    selecionarSistemaGestaoHabilitado: 'Favor selecionar o Sistema de Gestão habilitado para o auditor para remorer da lista',
    selecionarSistemaGestaoAdicionarLista: 'Favor selecionar o Sistema de Gestão para adicionar na lista',
    selecionarSistemaGestaoRemoverLista: 'Favor selecionar o Sistema de Gestão para remorer da lista',

    aprovarReprovarCadastroAuditor: 'Aprovar/Reprovar Cadastro de Auditor',
    executarAuditoria: 'Executar Auditoria',
    registroDecisaoSolicitacao: 'Aprovar/Reprovar',
    tituloRegistroDecisaoSolicitacao: 'Descreva a Decisão',
    tituloModalAprovarRepeovarCadastroAuditor: 'Descreva as observações de sua ação no Cadastro do Auditor, você deve também anexar um arquivo.',
    parecerAuditoriaFase2: 'Descreva o parecer sobre a Auditoria:',
    auditorSalvoSucesso: 'Dados do Auditor salvo com sucesso',

    cnpjIncorreto: 'CNPJ incorreto!',
    falhaDadosReceita: 'Falha ao recuperar dados na receita! Favor tentar novamente mais tarde ou insira seus dados dados manualmente.',
    falhaRecuperarInfoSistemaGestao: 'Falha ao Recuperar Sistema de Gestao',
    notaSalvar: 'Nota salva com sucesso',
    parecerFinalNota: 'Caro usuário IEL, favor entre com o parecer de final de desenvolvimento do Fornecedor.',
    notasRequisitos: 'Fornecedores com três notas abaixo de 5 ou cinco notas entre 5 e 7, estarão impedidos de participar da auditoria.',
    entrarNotas: 'Caro usuário IEL, favor entre com as notas de avaliação de desenvolvimento do Fornecedor.',
    notasRequisitos2: 'Por favor, entre com uma nota de 0 a 10 e use \'.\' pra especificar as casas decimais.',

    caixaEntradaTitulo: 'Caixa de Entrada - Itens com pendência de sua ação',
    caixaEntrada: 'Caro usuário, essa é a sua caixa de entrada. Toda solicitação que requer sua atenção está listada abaixo.',

    listaParticipantesSalvar: 'Lista de Participantes salvo com sucesso',
    eventoSalvar: 'Evento salvo com sucesso',
    eventoErroSalvar: 'Erro ao salvar Evento: ',

    formatoData: 'Favor entrar com a data no formato "dd/mm/aaaa"',

    tituloModalSolicitacaoAlteracaoCadastroFornecedor: 'Solicitação de alteração de cadastro',
    subTituloModalSolicitacaoAlteracaoCadastroFornecedor: 'Descreva uma observação sobre sua solicitação',
    tituloModalAprovacaoFornecedor: 'Aprovar/Reprovar Cadastro de Fornecedor',
    subTituloModalAprovacaoFornecedor: 'Descreva as observações de sua ação com o Cadastro do Fornecedor, você deve também anexar um arquivo.',
    selecionarFornecedoresListaConvidados: ' Por favor, selecione Fornecedores ou Usuários do sistema para montar a lista de presença do Encontro Técnico.',
    selecionarFornecedoresListaConvidados2: 'Você pode adicionar outras pessoas na lista.',
    marcarPresenca: 'Por favor, marque os participantes presentes na reunião.',
    marcarPresenca2: 'Você pode adicionar outras pessoas na lista.',
    selecionarTipoUsuario: 'Selecione fornecedores ou usuário do sistema',
    cadastrarConvidado: 'Entre com o nome do fornecedor, representates ou usuários do sistema, e clique no botão ao lado',
    cadastrarNomeParticipante: 'Entre com o nome do participante (usuário não cadastrado no sistema).',
    cadastrarTipoUsuario: 'Indique se é um usuário de mantenedora, fornecedor ou independente.',
    numeroItemRequisitoObrigatorio: 'O campo Número e título do item do requisito é obrigatório',
    nomeItemRequisitoObrigatorio: 'O campo Questões do item do requisito é obrigatório',

    arquivoExecutarAcao: 'Favor selecionar o arquivo para registrar a ação.',
    dataObrigatoria: 'Campo data é obrigatorio',
    falhaGeralSalvarAuditor: 'Falha geral ao salvar auditor',
    registrarResultadosReuniaoCE: 'Por favor, registre os resultados da reunião do CE em cada item da pauta lançada.',
    registrarResultadosReuniaoGT: 'Por favor, registre os resultados da reunião do Revisor Técnico em cada item da pauta lançada.',
    selecionarDataReuniao: 'Por favor, selecione a data e os itens para montar a pauta da reunião.',
    selecionarDataReuniao2: 'Para cada assunto, selecione os Fornecedores ou Auditores indicados.',
    selecioneDataReuniaoCE: 'Selecione a data da reunião do CE',
    selecioneDataReuniaoGT: 'Selecione a data da reunião do Revisor Técnico',
    selecionarItemPauta: 'Selecione um item da pauta e clique no botão adicionar ao lado.',
    selecionarAuditoresCE: 'Selecione os auditores em aprovação de cadastro',
    selecionarFornecedoresCE: 'Selecione os fornecedores com desenvolvimento finalizado e com parecer do IEL.',
    selecionarAcompanhamentoCE: 'Selecione os fornecedores em desenvolvimento.',
    selecionarSolicitacaoesCE: 'Selecione as Solicitações pendentes que serão aprovadas',
    fornecedoresDesenvolvimentoFinalizado: 'Fornecedores com desenvolvimento finalizado.',
    solicitacoesPendentes: 'Solicitações Pendentes',
    selecionarFornecedoresAuditoriaConcluida: 'Selecione os fornecedores com auditoria concluída.',
    selecioneFornecedoresCertificacao: 'Selecione os fornecedores com certificações.',
    fornecedoresAuditoriaConcluida: 'Fornecedores com auditoria concluída.',
    selecionarFornecedoresSolicitacaoReclamacao: 'Selecione os fornecedores com solicitação de reclamação.',
    fornecedoresSolicitaoReclamacao: 'Fornecedores com solicitação de reclamação.',
    selecioneFornecedoresApelacao: 'Selecione os fornecedores com solicitação de apelação.',
    selecioneFornecedoresCancelamentoCertificado: 'Selecione os fornecedores com solicitação de cancelamento de certificado.',
    selecioneFornecedoresSolicitacaoSistemaGestao: 'Selecione os fornecedores com solicitação de desenvolvimento em novo Sistema de Gestão.',
    selecioneFornecedoresAprovacaoCadastro: 'Selecione os fornecedores em aprovação de cadastro',
    selecioneFornecedoresCertificacaoExterna: 'Selecione os fornecedores com certificação ISO externa ao PRODFOR',

    falhaRegistrandoAcao: 'Falha na execução de sua ação!',
    aprovacaoRegistrada: 'Aprovação registrada com sucesso!',
    reprovacaoRegistrada: 'Reprovação registrada com sucesso!',
    erroAprovacaoCadastro: 'Erro aprovando cadastro!',
    erroReprovacaoCadastro: 'Erro reprovando cadastro!',
    //teste:'teste',

    acaoRegistrada: 'Ação registrada com sucesso!',

    tooltipParecerDesenvolvimento: 'Parecer final de desenvolvimento do Fornecedor',
    registrarParecerDesenvolvimento: 'Por favor, registre o parecer de desenvolvimento do fornecedor',

    falhaAlterarSenha: 'Erro ao tentar alterar sua senha. Por favor, entre em contato com o PRODFOR para verificar.',
    reprovadoNotasBaixo5: 'REPROVADO - três ou mais notas abaixo de 5',
    reprovadoNotasBaixoMedia: 'REPROVADO - cinco ou mais notas entre 5 e 7',
    reprovadoMediaBaixo5: 'REPROVADO - média abaixo de 5',

    instrucaoHomologarAuditores: 'Para homologar auditores, você deve marca-los na lista dos disponíveis, selecionar o período e adicionar à lista dos homologados com o botão de setinha correspondente!',
    tituloLongoCalendario: 'Caro usuário, selecione um dia no calendário para visualizar os detalhes ou use os botões ao lado para criar uma nova atividade.',
    reuniaoCEFechada: 'Reunião encerrada, favor verificar ata para ver as deliberações.',
    dataReuniao: 'Você não pode agendar uma reunião para uma data antes de hoje.',
    descricaoReuniaoCE_ATA: 'Decisão tomada na ata de reunião do Comitê Executivo. Para mais detalhes, verifique a ata.',
    descricaoReuniaoGT_ATA: 'Decisão tomada na ata de reunião do Revisor Técnico. Para mais detalhes, verifique a ata.',

    solicitacaoDescricao: 'O campo descricao é obrigatório',
    solicitacaoDetalhes: 'Detalhes da solicitação.',
    solicitacaoSga: 'O campo Sistema de gestão é obrigatório',
    solicitacaoParecer: 'O campo \'Parecer\' é obrigatório',

    acompanharSolicitacaoFornecedor: 'Caro usuário, acompenhe as solicitações dos Fornecedores.',
    orientacaoSolicitacoesUsuarioInterno:
        'Usuários internos: esta lista exibe todas as solicitações com workflow ativo. Para deliberação na Reunião CE, use também a pauta "Solicitação fornecedor" no agendamento da reunião e inclua o item na lista quando for analisado na ata.',
    semSolicitacoesDisponiveisCE:
        'Não há solicitações na estação do Comitê Executivo (CE) para esta pauta. Se o item ainda aguarda parecer do GT, abra a Reunião GT e use a pauta "Solicitação fornecedor" na estação 17.',
    tipoSolicitacaoSelect: 'Selecione o tipo de solicitação para filtro',
    adicionarFornecedor: 'Selecione o fornecedor, e clique no botão ao lado para adicionar na lista',
    adicionarAuditor: 'Selecione o auditor, e clique no botão ao lado para adicionar na lista',
    alertaAnaliseItensReuniao: 'Para salvar a ATA da reunião com as deliberações tomadas, você deve abrir e analisar todos os itens da pauta.',
    alertaGerarCertificadoItensAnalise: 'Favor gerar o número de certificado de todos is itens da lista Certificações.',
    semDadosParaExportarPDF: 'Sem dados para exportar na pauta!',

    tituloListaProcessos: 'Caro usuário, acompenhe aqui os processos de Certificação dos Fornecedores.',

    frase1AuditoriaFaseIFornecedor: 'Caro Fornecedor, favor fazer o download do formulário "(0)", preencher e fazer o upload do mesmo no sistema.',
    frase2AuditoriaFaseIFornecedor: 'Para documentos referenciados no formulário, favor fazer o upload na área indicada abaixo ou pelo menu "Documentos Fornecedor". Esses arquivos estarão disponíveis a toda equipe do PRODFOR.',
    frase3AuditoriaFaseIFornecedor: 'Esse procedimento se faz necessário para iniciarmos o processo de Auditoria em sua Empresa.',
    frase1AuditoriaFaseIAnalise: 'Caro usuário (0), favor analisar a documentação enviada pelo fornecedor, fazer o download do formulário "(1)", preencher e fazer o upload do mesmo no sistema.',
    frase1AuditoriaFaseIAnalisePlanoAcao: 'Caro usuário Revisor Técnico, favor analisar a documentação, os arquivos e a análise feita pelo Auditor, do processo de auditoria ancaminhado. Caso necessário, altere o formulário "(1)", enviado pelo auditor, e faça o upload na área indicada.',
    frase2AuditoriaFaseIAnalise: 'Havendo não conformidades na documentação, favor marcar o checkbox indicado. O fornecedor será avisado por email e ficará pendente em sua caixa de entrada.',
    frase3AuditoriaFaseIAnalise: 'Você pode também indicar um auditor para fazer a análise, click no botão "Indicar Auditor" e selecione-o na lista.',
    frase1AuditoriaFaseIPlanoFornecedor: 'Caro Fornecedor, foram encontradas não conformidades em sua documentação enviada. Favor verifique a análise feita pelo PRODFOR para corrigir os documentos enviados, e faça o upload dos mesmos nas áreas indicadas.',
    frase1AuditoriaFaseIAcompanhamentoFornecedor: 'Caro Fornecedor, acompanhe aqui o resultado da auditoria de Fase I em sua empresa.',
    frase2AuditoriaFaseIPlanoFornecedor: 'As não conformidades encontradas estão listadas nos documentos de resultado enviados pelo PRODFOR. Você pode também corrigir os documentos acessando o menu "Documentos Fornecedor".',

    tituloModalUnidadesEnvolvidas: 'Unidades envolvidas no escopo da Auditoria',
    subTituloModalUnidadesEnvolvidas: 'Caro Fornecedor, favor cadastrar as unidades envolvidas no escopo de sua Certificação.',
    subTituloModalUnidadesEnvolvidasUsuario: 'Unidades envolvidas no escopo de Certificação.',

    subTituloModalIndicarAuditor: 'Caro usuário Revisor Técnico, favor selecionar o Auditor na lista abaixo para fazer a análise da documentação desse fornecedor.',
    tituloAcompanhamentoProcessosFornecedor: 'Acompanhamento de processo do fornecedor',
    tituloAcompanhamentoProcessosAuditor: 'Acompanhamento de processo do auditor',
    indicacaoObrigatoria: 'O campo Indicação é Obrigatorio',
    frase1ProgramacaoAuditoria: 'Caro usuário, por favor, clique no botão de ação para programar a auditoria do fornecedor.',

    programacaoRemarcarFornecedor: 'Programação de auditoria deve ser remarcada',
    periodoExecucaoAuditoria: 'Período de execução de auditoria',
    dadosSalvosAuditoria: 'Dados da auditoria salvos com sucesso',
    tituloProgramacaoAuditoria: 'Programação de Auditoria - Agendamento e seleção de requisitos',
    subTituloProgramacaoAuditoria1: 'Auditor, por favor, entre em contato com o Fornecedor e agende o dia da auditoria fase II.',
    subTituloProgramacaoAuditoria2: 'Para programar a auditoria, por favor clique em "Marcar requisitos de auditoria".',
    itensRequisitosFase2: 'Itens de requisito para auditoria fase II',
    subTituloItensRequisitosFase2_1: 'Por favor, selecione os itens de requisitos de acordo com o escopo da auditoria.',
    subTituloItensRequisitosFase2_2: 'Observação: Todos os requisitos estão marcados por padrão, desmarque somente os requisitos ou itens de requisito, fora do escopo da auditoria.',
    subTituloGTProgramacaoAuditoria1: 'Caro Revisor Técnico, favor programar a previsão da auditoria.',
    subTituloGTProgramacaoAuditoria2: 'Caro Revisor Técnico, o Fornecedor solicitou alterações na programação da auditoria.',
    subTituloGTProgramacaoAuditoria3: 'Favor verificar e fazer os ajustes finais acordados.',
    subTituloFornecedorProgramacaoAuditoria1: 'Caro Fornecedor, veja previsão da programação de sua auditoria.',
    subTituloFornecedorProgramacaoAuditoria2: 'O Auditor líder entrará em contato para agendar a data de execução de sua auditoria fase II.',
    subTituloFornecedorProgramacaoAuditoria3: 'Caso deseje alterar algum dado na programação (carga horária, período ou equipe de auditoria), descreva no campo abaixo suas solicitações e clique em "Criar Solicitação" para nos enviar. Iremos verificar e retornar o mais breve.',

    gtAdicionarParecerSolicitacao: 'Favor adicionar seu parecer para solicitação do fornecedor.',
    ceAdicionarParecerSolicitacao: 'Secretaria, favor adicionar seu parecer para solicitação do fornecedor',
    ielAdicionarParecerSolicitacao: 'IEL, favor adicionar seu parecer para solicitação do fornecedor.',
    adicionarDecisaoSolicitacao: 'Favor adicionar sua decisão para solicitação do fornecedor.',
    descreverObservacoesParecerFornecedor: 'Descreva as observações de parecer para a solicitação do fornecedor. Será levado para a reunião do CE.',


    previsaoNaoMarcada: 'Previsão não marcada',
    periodoNaoAgendado: 'Período não agendado',
    cargaHorariaNaoDefinida: 'Carga horária não definida',
    naoDefinida: 'Não definida',
    equipeNaoDefinida: 'Equipe de auditores não definida',
    diaNaoMarcado: 'Dia da auditoria não marcado pelo auditor',
    solicitacaoCadastroEfetivado: 'Seu cadastro precisa estar Efetivado para realizar solicitações',
    descreverSolicitacaoFornecedor: 'Caro Fornecedor, descreva sua solicitação. Ela será levada ao Comitê Executivo, retornaremos em breve com o resultado.',
    subTituloFase2GT1: 'Favor verificar as recomendações do Revisor Técnico e com o resultado da reunião do CE aprovar ou não a certificação do Fornecedor.',
    subTituloFase2GT2: 'Revisor Técnico, favor analisar os itens auditados pela equipe de auditoria e fazer suas recomendações de certificação para serem levadas à reunião do CE.',
    subTituloFase2Fornecedor1: 'Caro Fornecedor, foram encontradas não conformidades na realização de sua auditoria, por favor preencha o plano de ação para cada uma delas.',
    subTituloFase2Fornecedor2: 'Você pode enviar um arquivo para melhor demonstrar seu plano de ação.',
    subTituloFase2Auditor1: 'Caro Auditor, favor preencher o checklist de auditoria marcado para cada item se foram encontrados não conformidades e as evidências.',
    subTituloFase2Auditor2: 'Você também pode fazer o download da planilha para preenchimento off-line e carregar posteriormente.',
    itemAjusteNecessario: 'Não conformidade de grau menor apontado pelo auditor',
    itemDentroNorma: 'Item em conformidade com a norma',
    itemForaNorma: 'Não conformidade de grau maior apontado pelo auditor',
    itemForaNormaNaoConformidade: 'Não conformidade de grau maior apontado pelo auditor',
    selecionarMotivoCancelamento: 'Selecione o motivo de cancelamento',
    subTituloFase2ValidarPlanoForn1: 'Caro usuário, favor validar o plano de ação imputado pelo fornecedor.',
    subTituloFase2ValidarConstatacaoAuditoria: 'Caro fornecedor, favor dar seu "De acordo" em todos os itens de não conformidade lançados pelo auditor',

    subTituloModalCarregarPlanilhaAuditoria1: 'Carregue aqui a planilha off-line de auditoria.',
    subTituloModalCarregarPlanilhaAuditoria2: 'ATENÇÃO: Ao carregar esse arquivo, você perderá qualquer informação preenchida anteriormente.',

    sucessoSolicitacaoAlteracaoCadastral: 'Solicitacão de alteração cadastral salva com sucesso',
    alteracoesControladas: 'O cadastro desse fornecedor está aprovado! As alterações são controladas.',
    nenhumaAlteracaoDetectada: 'Nenhuma alteração foi detectada para salvar.',
    sessaoEncerrada: 'Sessão encerrada. Favor logar-se novamente.',
    falhaRegistrandoEvento: 'Falha ao atualizar a auditoria no calendário.',
    descricaoCertificadoExperiencia: 'Certificado de experiência. Auditor: _NOME_',
    fornecedorSemNotasAvaliacao: 'O fornecedor ainda não possui notas de avaliação lançada',
    selecionarPrevisaoFinal: 'Você deve selecionar a previsão final de execução da auditoria',
    selecionarPrevisaoInicial: 'Você deve selecionar a previsão inicial de execução da auditoria',
    mesFinalIgualMaiorInicial: 'O mês final deve ser o mesmo ou depois do mês inicial',
    selecionarQuinzenaExecucao: 'Você deve selecionar a quinzena de execução da auditoria',
    selecionarMesPrevisao: 'Você deve selecionar o mês de execução da auditoria',
    selecionarMesExecucaoDentroPrevisao: 'O mês de agendamento para execução da auditoria deve estar dentro do período de previsão',
    selecionarAuditorLider: 'Por favor, selecione o auditor líder',
    selecionarCargaHorariaTecnicaLider: 'Você deve entrar com o valor da carga horária técnica do líder',
    selecionarCargaHorariaDeslocamentoLider: 'Você deve entrar com o valor da carga horária de deslocamento do líder',
    selecionarCargaHorariaTecnicaSegundo: 'Você deve entrar com o valor da carga horária técnica do segundo auditor',
    selecionarCargaHorariaDeslocamentoSegundo: 'Você deve entrar com o valor da carga horária de deslocamento do segundo auditor',
    selecionarCargaHorariaTecnicaTraine: 'Você deve entrar com o valor da carga horária técnica do auditor trainee',
    selecionarCargaHorariaDeslocamentoTraine: 'Você deve entrar com o valor da carga horária de deslocamento do auditor trainee',
    escopoAuditoria: 'Você deve entrar com as recomendações da auditoria',
    falhaRecuperarDadosAuditoria: 'Falha ao recuperar dados da auditoria em andamento!',
    falhaRecuperarRequisitosAuditoria: 'Falha ao recuperar dados dos requisitos da norma para auditoria fase II',
    marcarRequisitosAuditoria: 'Você deve verificar os requisitos de sua auditoria em "Marcar requisitos de auditoria", antes de agenda-la',
    marcarDadosAuditoria: 'Favor definir as datas da auditoria agenda-la',
    dataMaximaInicioAuditoria: 'A data de início da auditoria deve estar dentro da quinzena programada pelo Revisor Técnico, para essa auditoria.',
    verficarDadosAuditoria: 'Verifique os detalhes da auditoria em andamento',
    auditoriaAtualizadaSucesso: 'Auditoria atualizada com sucesso!',
    verifiqueChecklistSelecionado: 'Verifique os itens do checklist selecionados pelo Auditor para a auditoria em andamento.',
    verificaNotaFornecedor: 'Verifique se inseriu pelo menos uma nota',
    subTituloSistemaGestaoCoordenador: 'Por favor, defina ao menos um Sistema de Gestão para o Revisor Técnico',
    auditoriaSuspensaSubTitulo: 'Essa auditoria está suspensa, para retorna-la basta definir as datas no agendamento e salvar.',
    recuperarDadosAuditor: 'Existe um auditor cadastrado com esse CPF, aguarde que carregaremos seus dados!',
    alterarSenhaPrimeiroAcesso: 'Favor alterar sua senha de primeiro acesso',
    selecionarListaSistemaGestao: 'Favor selecionar o(s) Sistema(s) de Gestão para essa ação',
    solicitadaAprovacaoSG: 'Solicitada aprovação para o(s) Sistema(s) de Gestão _SG_.',
    removerListaNaoPermitido: 'Não é possível remover um item em aprovação ou aprovado da lista.',
    removerSGHabilitado: 'Sistema de Gestão _SG_ na qualificação de _QUALIF_, removido com sucesso.',
    aprovarReprorarCadastroAuditor: 'Aprovar/Reprorar cadastro do Auditor',
    informacoesSalvasDesenvolvimento: 'Informações do grupo de desenvolvimento salva.',
    informacoesSalvasMantenedora: 'Mantenedora de indicação salva.',
    enviarAnaliseGT: 'Enviar cadastro do auditor para análise do Revisor Técnico',
    avaliacaoCadastroAuditor: 'Cadastro avaliado pela Secretaria PRODFOR',
    aprovacaoSistemaGestaoSucesso: 'Aprovação do Sistema de Gestão efetuada com sucesso.',
    aprovacaoSistemaGestaoFalha: 'Erro ao aprovar o Sistema de Gestão para o auditor. Favor entrar em contato com o PRODFOR.',
    notaSalva: 'Nota(s) salva(s) com sucesso',
    solicitacaoDesenvolvimentoSalvar: 'Solicitação salva com sucesso',
    indicacaoAuditorFaseISucesso: 'Inidicação efetuada com sucesso! A documentação desse fornecedor está na Caixa de Entrada do auditor para análise!',
    indicacaoGTFaseISucesso: 'Inidicação efetuada com sucesso! A documentação desse fornecedor está em sua Caixa de Entrada para análise!',
    selecionarAuditorAnaliseFaseI: 'Você deve selecionar um auditor homologado para direcionar a análise da documentação desse fornecedor.',
    falhaSalvarRequisicao: 'Ocorreu algum erro ao salvar sua requisição!',
    permicaoSalvarChecklistAuditoria: 'Somente é permitido salvar o progresso da auditoria no dia agendado ou após.',
    permicaoFinalizarChecklistAuditoria: 'Somente é permitido finalizar o relatório da auditoria na data agendada ou após.',
    sucessoSalvarAuditoria: 'Auditoria salva com sucesso! <br>Para finaliza-la, por favor, clique em "Fechar relatório de auditoria".',
    sucessoSalvarAuditoriaPlanoAcao: 'Plano de ação salvo com sucesso! <br>Para finaliza-lo, por favor, clique em "Fechar plano de ação auditoria".',
    relatorioFinalizadoSucesso: 'Relatório de auditoria finalizado com sucesso!',
    selecionarPlanilhaAuditoria: 'Favor selecionar a planilha preenchida para carregar os dados da auditoria!',
    preencherEvidenciaAuditoria: 'Favor preencher a evidência em todos os itens da auditoria, marcados como não conforme!<br>',
    preencherProblemasAuditoria: 'Favor preencher a descrição do problema detectado nas constatações em todos os itens marcados como não conforme!<br>',
    preencherEvidenciaAuditoriaConstatacoes: 'Favor preencher as evidências da não conformidade em todos os itens  marcados como não conforme!<br>',
    preencherRequisitosNaoAtenditos: 'Favor preencher os requisitos não atendidos em todos os itens marcados como não conforme!<br>',
    preencherCargaHorariaExecucao: 'Por favor, preencha a carga horária executada!',
    auditoriaSuspensaMensagemAuditor: 'Auditoria suspensa, você não poderá alterar seus dados até que o PRODFOR definida uma programação.',
    subTituloAnaliseGTAuditoria: 'Caro usuário, favor analisar os resultados da execução da auditoria, para registrar o parecer e enviar a decisão para o Comitê Executivo.',
    subTituloAnaliseCEAuditoria: 'Caro usuário, favor verificar o parecer de análise do Revisor Técnico para a auditoria e informar a decisão da Certificação',
    subTituloAnaliseRelatorioAuditoria: 'Caro usuário, favor dar seu "de acordo" na execução da auditoria em sua empresa',
    semSistemaGestaoAprovacao: 'Sem Sistemas de Gestão para aprovação.',
    modalDadosAuditorMensagemDeletar: 'Deseja remover essa habilitação do auditor?',
    modalDadosAuditorMensagemDeletar2: 'Essa ação, também removerá a homologação.',
    descreverRecomendacoesCertificacao: 'Favor descrever as recomendações dessa auditoria de certificação/recertificação.',
    cancelarCertificadoConfirmacao: 'Deseja cancelar o certificado deste fornecedor? Essa ação também anulará qualquer auditoria futura deste fornecedor para o Sistema de Gestão!',
    reativarCertificadoConfirmacao: 'Deseja reativar o certificado deste fornecedor?',
    inserirNota: 'Insira a nota corretamente',
    suspenderCertificadoConfirmacao: 'Deseja suspender temporáriamente o certificado deste fornecedor?',
    programarNovaAuditoriaConfirmacao: 'Deseja programar nova auditoria deste fornecedor no Sistema de Gestão atual?',
    iniciarProcessoCertificacaoConfirmacao: 'Deseja iniciar o processo de certificação deste fornecedor no Sistema de Gestão atual?',
    preencherCausasProvaveisPlanoAcaoAuditoria: 'Favor preencher o campo de "Causas Prováveis" em todos os itens do plano de ação quando apontado uma não conformidade pelo auditor!<br>',
    preencherPrazosPlanoAcaoAuditoria: 'Favor preencher o campo de "Prazos" em todos os itens do plano de ação quando apontado uma não conformidade pelo auditor!<br>',
    preencherResponsavelPlanoAcaoAuditoria: 'Favor preencher o campo de "Responsável" em todos os itens do plano de ação quando apontado uma não conformidade pelo auditor!<br>',
    preencherAcoesCorretivasPlanoAcaoAuditoria: 'Favor preencher o campo de "Ações Corretivas" em todos os itens do plano de ação quando apontado uma não conformidade pelo auditor!<br>',
    aprovacaoHabilitacaoQualidadeAuditor: 'Aprovação de habilitação para a qualidade de "_QUALIFICACAO_" no Sistema de Gestão.',
    retirarHabilitacaoQualidadeAuditor: 'Retirada da qualificação de "_QUALIFICACAO_" do auditor.',
    reuniaoCERegistradaSucesso: 'Reunião do Comitê Executivo registrada com sucesso!',
    reuniaoCEAtualizada: 'Reunião do Comitê Executivo atualizada com sucesso!',
    reuniaoCEDataAgendaOcupada: 'Já existe uma reunião do Comitê Executivo agendada para esse dia.<br>Por favor, selecione outra data.',
    reuniaoCEEncerradaSucesso: 'Reunião do Comitê Executivo encerrada com sucesso!',
    falhaSalvarItensCE: 'Falha salvar itens da reunião do Comitê Executivo',
    reuniaoGTRegistradaSucesso: 'Reunião do Revisor Técnico registrada com sucesso!',
    reuniaoGTAtualizada: 'Reunião do Revisor Técnico atualizada com sucesso!',
    reuniaoGTDataAgendaOcupada: 'Já existe uma reunião do Revisor Técnico agendada para esse dia.<br>Por favor, selecione outra data.',
    reuniaoGTEncerradaSucesso: 'Reunião do Revisor Técnico encerrada com sucesso!',
    falhaSalvarItensGT: 'Falha salvar itens da reunião do Revisor Técnico',
    naoConformeAlterado: 'Não conformidade do item alterado com sucesso.',
    fornecedoresAvaliacaoDesempenhoAuditoria: 'Fornecedores com auditoria fechada, avaliação de desempenho.',
    verificarDetalhesCertificados: 'Verifique os detalhes do certificado',
    listaCertificadosEmitidos: 'Lista dos Certificações Emitidos',
    planilhaCarregaSucesso: 'Planilha carregada com sucesso!',
    falhaCarregarItemPlanilha: 'Não foi possível resgatar o item "_ITEM_..." da planilha lida. Favor usar a planilha de modelo exportada pelo sistema.',
    falhaCarregarItemConfirmidade: 'O item da planilha "_ITEM_...", não foi marcado como conforme ou não.',
    selecioneSuasDecisoes: 'Selecione suas decisões para a certificação',
    tooltipBotaoChacklistAlterarConformidades: 'Verificar checklist e alterar itens de conformidade',
    naoConformidadeAlterada: 'Não conformidade do item alterado com sucesso.',
    alteracoesSolicitadasFornecedor: 'Alterações efetuadas por solicitação do Fornecedor',
    selecioneAuditoriasReuniao: 'Selecione as auditorias para análise na reunião',
    erroCarregandoSGAuditor: 'Falha carregando workflows de aprovação dos Sistemas de Gestão desse auditor.',
    falhaRecuperarListaCertificados: 'Falha ao recuperar lista com os certificados do PRODFOR',
    listaAuditoriasFaseI: 'Lista de auditorias na Fase I (Documentação).',
    selecionarTipoSolicitacao: 'Selecione algum tipo de solicitação',
    selecionarData: 'Selecione uma data',
    selecionarTipoAuditoria: 'Selecione algum tipo de auditoria',
    selecionarTipoSG: 'Selecione algum tipo de sistema gestao',
    selecionarDataInicio: 'Selecione uma data de Inicio',
    selecionarDataFim: 'Selecione uma data de Fim',
    selecionarCertificado: 'Selecione algum tipo de Certificado',

    verifiqueChecklistCertificado: 'Verifique os itens do checklist de execução dessa auditoria',
    relatorioAuditoria: 'Relatório final de auditoria',

    salvarRespostaPerguntas: 'Perguntas de satisfação salvas com sucesso',
    perguntaObrigatorio: 'O campo Pergunta é obrigatório!',
    tipoPerguntaObrigatorio: 'O campo de Tipo Pergunta é obrigatório!',
    selecioneTipo: 'Selecione o Tipo da Pergunta!',
    respostaObrigatoria: 'É obrigatório responder a todas perguntas!',

    uploadDocsFornecedorFase1: 'Faça o upload dos documentos referenciados no checklist',
    uploadArquivoFormulario: 'Favor fazer o upload do formulário!',
    uploadArquivosGeralPeloMenosUm: 'Você deve fazer o upload de pelo menos um arquivo na sessão de uploads gerais',
    declaracaoAuditorMsg: 'A Coordenação Executiva do PRODFOR, declara para os devidos fins que o auditor <strong>(1)</strong> atuou nas seguintes auditorias:',

    digitePerguntaPesquisa: 'Digite a pergunta da pesquisa',
    fornecedorResponderPesquisa: 'Caro Fornecedor, por favor, responda à pesquisa de safisfação abaixo referente à sua última auditoria.',
    secretariaAnalisePesquisa: 'Caro usuário, por favor, analise as respostas do fornecedor quanto à pesquisa de safisfação, referente à última auditoria realizada.',
    toolTipRespostaNumero: 'Entre com: "1" para Insatisfeito / "2" para Regular / "3" para Bom / "4" para Ótimo',
    digiteResposta: 'Digite a sua resposta',
    gtAvaliarDesempenho: 'Caro Revisor Técnico, favor avaliar o desempenho técnico do Auditor para essa auditoria. De uma nota de zero a dez.',
    auditorAvaliarDesempenho: 'Caro Auditor, favor avaliar o desempenho técnico do Auditor Trainee para essa auditoria. De uma nota de zero a dez.',
    perguntaAdicionada: 'Pergunta adicionada com sucesso!',
    perguntaAtualizada: 'Pergunta atualizada com sucesso!',
    perguntaRemovida: 'Pergunta removida com sucesso!',
    perguntaNaoPodeRemover: 'Essa pergunta não pode ser removida, pois já foi respondida por algum fornecedor!',
    selecioneCertificado: 'Selecione o certificado',
    selecioneInicioCertificacao: 'Por favor, selecione a fase inicial de certificação',
    selecioneTipoAuditoriaCertificacao: 'Por favor, selecione o tipo da auditoria para o processo de certificação',
    semDadosImprimirCertificado: 'Sem dados no sistema para imprimir o certificado! Certificado carregado do legado',
    certificadoCancelado: 'Certificado cancelado com sucesso',
    certificadoSuspenso: 'Certificado supenso com sucesso',
    certificadoAtivo: 'Certificado reativado com sucesso',
    auditoriaProgramacaoIniciada: 'Auditoria em programação. Favor verificar sua caixa de entrada!',
    processoIniciado: 'Processo iniciado com sucesso',
    selecionaDataValidade: 'Selecione a nova data de validade',

    alteracaoEscopo: 'Alteração do escopo',
    solicitacaoExistente: 'Já existe uma solicitação para a alteração do escopo desse certificado',

    adicionarParecerAuditoria: 'Favor adicionar seu comentário para auditoria',

    existeWorkflowAndamento: 'Já existe um workflow de certificação para esse fornecedor em andamento. Por favor, verifique no menu de "Auditorias -> Fase II".',
    existeAuditoriaAndamento: 'Já existe uma auditoria de certificação na agenda desse fornecedor. Por favor, verifique no menu de "Auditorias -> Fase II".',

    auditoresIguais: 'Favor selecionar segundo auditor diferente do auditor lider',
    validarAudiotoriaAntetior: 'Não localizado os dados da auditoria anterior!',
    validarPlanoAcaoFornecedor: 'Validação do plano de ação do fornecedor',
    desejaAbrirApelacao: 'Deseja abrir uma apelação para análise do Revisor Técnico dessa auditoria?',
    solicitacaoJaEnviada: 'Solicitação já encaminhada ao Revisor Técnico',
    solicitacaoApelacaoResultadoAuditoria: 'Solicitação criada automaticamente pelo sistema.\nFornecedor não concorda com o apontamento dado pelo auditor na constatação da auditoria.',
    pegarAnaliseTooltip: 'Pegar documentação para análise',
    trocarAuditorTooltip: 'Trocar de auditor para análise da documentação',
    verifiqueAuditoriaAnterior: 'Verifique os dados da auditoria anterior',
    semDadosRelatorioExibir: 'Sem dados do relatório para exibir! Certificado carregado do legado.',
    semDadosCertificadoExibir: 'Sem dados de endereços do certificado para exibir! Certificado carregado do legado.',
    falhaRecuperarDadosCertificado: 'Não foi possível recuperar as informações do Certificado desse fornecedor!',
    favorDescreverSolicitacaoAlteracaoProgramacao: 'Você deve descrever sua solicitação informando quais itens deseja solicitar alteração',
    previsaoMesResumo: '_MESI_ a _MESF_ de _ANO_',
    falhaIniciarWorkflowAuditoria: 'Falha ao iniciar o processo de auditoria',
    processoJaExiste: 'Já existe um processo em andamento para essa auditoria!',
    selecioneEstacaoInicial: 'Selecione a estação inicial',
    selecioneTipoAuditoria: 'Selecione o tipo da auditoria',
    iniciarProcessoAuditoria: 'Inicia o processo de certificação para a auditoria correspondente',
    selecionaOrgaoEmissor: 'Entre com o orgão emissor do certificado',
    exibirItensCompletosOuNaoConformes: 'Exibir todos itens (ou apenas os itens identificados com Ajuste ou Não Conforme)',
    planoAcaoFornecedorComentarioAuditor: 'Favor adicionar seu comentário para análise do plano de ação do fornecedor',
    refereciaMesIgnorada: 'A referência do mês será ignorada',
    tituloListaAuditoresExport: 'Lista de auditores cadastrados no PRODFOR',
    tituloListaFornecedoresExport: 'Lista de fornecedores cadastrados no PRODFOR',
    tituloListaCertificadosExport: 'Lista de certificados no PRODFOR',
    tituloListaAuditoriasExport: 'Lista de programação das auditorias no PRODFOR',
    tituloRelatorioAuditoriasExport: 'Relatório de auditorias no PRODFOR',
    tituloFiltroRelatorioAuditoria: 'Selecione os itens para filtrar as auditorias e clique em "Pesquisar"',
    PRODFOR: 'Programa Integrado de Desenvolvimento e Qualificação de Fornecedores',
    cargaHorariaTecDeslPrevista: 'CH Prevista (Téc+Desloc)',
    cargaHorariaTecDeslExec: 'CH Executada (Téc+Desloc)',
    falhaRecuperarDadosRelatorio: 'Falha ao recuperar dados do relatório solicitado',
    alertaRelatorioPendenciasAuditoriaSelecaoTipo: 'Por favor, selecione o tipo de pendência das auditorias: "Previstas e não programadas" ou "Programadas e não agendadas".',
    semPendenciasRelatorio: 'Sem pendências para exibir...',
    semDadosParaExportar: 'Sem dados para exportar',
    arquivoCertificacaoExterna: 'Por favor, marque aqui caso o arquivo for um certificado ISO emitido por um orgão externo ao PRODFOR',
    substituirArquivoCertificadoFornecedor: 'Já existe um arquivo marcado como certificado, deseja substituir por esse?',
    analiseArquivoCertificado: 'Caro usuário, o fornecedor fez o upload do arquivo de certificado ou substituiu um arquivo antigo. Favor analisar e registrar sua ação.',
    forncedorPossueCertificacaoExterna: '* Esse fornecedor possui certificação ISO',
    mensagemConfirmacaoExcluirEndereco: 'Deseja realmente excluir esse endereço de seu escopo?',
    confirmarDeletarArquivo: 'Deseja realmente deletar o arquivo "{0}"?',
    frase4AuditoriaFaseIAnalise: 'Caso deseje aprovar com ressalvas para serem analisadas na auditoria presencial Fase II, favor adicionar as observações no campo indicado abaixo.',
    encaminharFornecedorCorrecoes: 'Encaminhar ajustes para o fornecedor nesse momento?',
    resumoAuditoriaNC: 'NC-: {0}\nNC+:{1}',
    recomendacoesRT: 'Acompan.: {0}\nCertif.: {1}',

    erroSalvarCertificacaoISO: 'Erro ao salvar certificação ISO',
    erroSalvarFornecedor: 'Erro ao salvar fornecedor',
    erroSalvarLogo: 'Erro ao salvar logo',

    dataErrada: 'Insira uma data válida',

    tituloModalTermoDeUso: 'TERMOS DE USO SIP',
    descricaoTermoDeUso: `
          <div style="font-family: Arial, sans-serif; line-height: 1.5;">
            <h3 style="margin-top: 15px; margin-bottom: 15px;">Sistema de Informações do PRODFOR</h3>
            
            <p>Este Termo de Uso ("Termo") estabelece as condições para o uso do SIP -- Sistema de Informação do PRODFOR, disponível no site <a href="https://www.prodforsip.com.br" target="_blank">www.prodforsip.com.br</a>.</p>
            
            <h4 style="font-weight: bold; margin-top: 20px;">1. Da Aceitação ao presente Termo de Uso</h4>
            
            <div style="padding-left: 20px;">
              <p>1.1. Ao acessar e utilizar o SIP -- Sistema de Informação do PRODFOR, através do site <a href="https://www.prodforsip.com.br" target="_blank">www.prodforsip.com.br</a>, o usuário declara estar ciente e de acordo com as cláusulas deste Termo.</p>
              
              <p>1.2. Caso não concorde, você não deverá utilizar este sistema.</p>
            </div>
            
            <h4 style="font-weight: bold; margin-top: 20px;">2. Siglas e Definições</h4>
            
            <div style="padding-left: 20px;">
              <p>2.1. Para fins deste Termo de uso, considera-se as seguintes siglas e definições:</p>
              
              <ul style="list-style-type: disc; padding-left: 20px;">
                <li>PRODFOR: Programa Integrado de Desenvolvimento e Qualificação de Fornecedores;</li>
                <li>Fornecedor: É a empresa que se candidata ou é indicada à Qualificação do Prodfor</li>
                <li>SIP: Sistema de Informação do Prodfor</li>
                <li>CE: Comitê Executivo SG: Sistema de Gestão</li>
                <li>SG: Sistema de Gestão</li>
                <li>RPA: Recibo de pessoa autônoma</li>
              </ul>
            </div>
            
            <h4 style="font-weight: bold; margin-top: 20px;">3. Da Descrição das Atividades e Funcionalidades do SIP -- Sistema de Informação do PRODFOR</h4>
            
            <p style="padding-left: 20px;">3.1. O PRODFOR é um programa que integra grandes empresas compradoras, para a promoção do desenvolvimento de seus fornecedores locais, garantindo a estes, dentre outras oportunidades:</p>
            
            <div style="padding-left: 40px;">
              <p>3.1.1. Participação em encontro de negócios;</p>
              <p>3.1.2. Encontros técnicos e fóruns;</p>
              <p>3.1.3. Eventos para certificação e recertificação; e</p>
              <p>3.1.4. Acesso direto das mantenedoras ao cadastro dos fornecedores no banco de dados do programa.</p>
            </div>
            
            <p style="padding-left: 20px;">3.2. O Programa tem como missão desenvolver relacionamentos empresariais sustentáveis, pelo contínuo aprimoramento da gestão das empresas da cadeia de suprimentos das Mantenedoras e do mercado e promover a identificação, desenvolvimento, qualificação, avaliação e reconhecimento de fornecedores para as empresas Mantenedoras do Prodfor e para o mercado.</p>
            
            <h4 style="font-weight: bold; margin-top: 20px;">4. Uso Adequado do SIP</h4>
            
            <div style="padding-left: 20px;">
              <p>4.1. O usuário compromete-se a utilizar a aplicação de forma lícita e em conformidade com a legislação aplicável, abstendo-se de:</p>
              
              <div style="padding-left: 20px;">
                <p>4.1.1. Utilizar o sistema para fins ilegais, fraudulentos ou que possam prejudicar terceiros; e</p>
                <p>4.1.2. Realizar qualquer tipo de interferência nos sistemas da aplicação.</p>
              </div>
            </div>
            
            <h4 style="font-weight: bold; margin-top: 20px;">5. Limitação de Responsabilidade</h4>
            
            <div style="padding-left: 20px;">
              <p>5.1. O PRODFOR é desenvolvido e mantido por grandes organizações, sendo estas: ArcelorMittal Brasil, Cesan, Chemtrade, EDP Espírito Santo, Petrobrás, Samarco, Sicoob ES, Suzano e Vale, com o apoio institucional do Sebrae-ES. A coordenação executiva é exercida pelo Instituto Euvaldo Lodi (IEL-ES) e tem o apoio da Federação das Indústrias do Estado do Espírito Santo (FINDES).</p>
              
              <p>5.2. Os mantenedores e a coordenação executiva do PRODFOR não se responsabilizam por qualquer dano decorrente de mau uso do SIP pelos fornecedores, bem como a inobservância ao presente Termo e as demais normas e Políticas vinculadas ao uso da plataforma.</p>
            </div>
            
            <h4 style="font-weight: bold; margin-top: 20px;">6. Confidencialidade e Proteção dos Dados Pessoais</h4>
            
            <div style="padding-left: 20px;">
              <p>6.1. São adotadas medidas técnicas e administrativas de segurança adequadas e em conformidade com as leis e regulamentos aplicáveis, em especial a Lei Geral de Proteção de Dados Pessoais (LGPD), visando garantir o sigilo e a proteção das informações fornecidas durante o uso do SIP;</p>
              
              <p>6.2. Todas as informações serão tratadas em conformidade com a <a href="https://findes.com.br/lgpd/politica-de-privacidade/" target="_blank">Política de Privacidade da FINDES</a>, aplicável ao IEL-ES. Assim, solicitamos que leia o referido documento para que tenha total ciência de como tratamos seus dados pessoais.</p>
              
              <p>6.3. Para exercer os direitos previstos no artigo 18, da Lei nº 13.709/2018 (Lei Geral de Proteção de Dados Pessoais - LGPD), acesse: <a href="https://findes.com.br/lgpd/direitos-do-titular/" target="_blank">https://findes.com.br/lgpd/direitos-do-titular/</a>.</p>
              
              <p>6.4. Em caso de dúvidas sobre como tratamos os dados pessoais fornecidos para o uso do SIP, entre em contato através do e-mail <a href="mailto:LGPD@findes.org.br">LGPD@findes.org.br</a>, e fale com a Encarregada de Dados da FINDES.</p>
            </div>
            
            <h4 style="font-weight: bold; margin-top: 20px;">7. Do cadastro de Fornecedor PRODFOR</h4>
            
            <div style="padding-left: 20px;">
              <p>7.1. Por meio de indicação de alguma mantenedora ou por auto candidatura o fornecedor deve ir no site www.prodforsip.com.br e realizar o cadastro;</p>
              
              <p>7.2. A Secretaria após identificar na caixa de entrada do SIP um cadastro de fornecedor, deve:</p>
              
              <ul style="list-style-type: disc; padding-left: 20px;">
                <li>Analisar se o cadastro está completo, caso esteja faltando dados, o fornecedor deve ser contactado para complementá-lo;</li>
                <li>Se estiver completo:
                  <ol style="list-style-type: lower-alpha; padding-left: 20px;">
                    <li>Deve ser inserida a informação se é candidato ou indicado</li>
                    <li>Apontar no cadastro qual é o grupo de desenvolvimento (ano)</li>
                    <li>Remeter ao Comitê Executivo para análise, por e-mail ou em reunião.</li>
                  </ol>
                </li>
              </ul>
              
              <p>7.3. A decisão do CE deve ser registrada no SIP;</p>
              
              <p>7.4. O SIP envia decisão ao fornecedor via e-mail cadastrado;</p>
              
              <p>7.5. Se o cadastro for aprovado e o fornecedor for aderir ao Prodfor deve assinar o Termo de Adesão via ferramenta de assinatura digital;</p>
              
              <p>7.6. Se o fornecedor for desenvolver o SG com o IEL, deve assinar proposta de serviço específica da equipe de Gestão, conforme os procedimentos da área;</p>
              
              <p>7.7. Se o fornecedor aderiu ao Prodfor, mas optar por outra consultoria, ele deve apresentar ao Coordenador executivo um Plano de Desenvolvimento Específico. Se aprovado, o IEL realizará visitas de acompanhamento mensalmente durante a fase de desenvolvimento;</p>
              
              <p>7.8. Se o cadastro for aprovado e o fornecedor já possuir sistema de gestão implementado da mesma Norma pleiteada no Prodfor, ele deve apresentar certificado válido e chancelado e ser enviado diretamente para o processo de auditoria conforme procedimento PR-GEM-06 Processo de Qualificação de fornecedores;</p>
              
              <p>7.9. Se ele não for aprovado encerra o atendimento pelo Prodfor para aquele ano do desenvolvimento e comunica a área de gestão do IEL para verificar se há algum serviço similar que possa ser ofertado ao cliente;</p>
              
              <p>7.10. A qualquer momento do Desenvolvimento a mantenedora pode indicar o fornecedor, nesse caso o cadastro da empresa deve ser adequado no item indicação;</p>
              
              <p>7.11. Quando o fornecedor é elegível ao aporte financeiro a Secretaria envia a informação ao Sebrae de que o mesmo aderiu ao Prodfor e requer o subsídio financeiro para Desenvolvimento do SG;</p>
              
              <p>7.12. Quando os dados do fornecedor forem alterados, ele deve entrar no SIP e realizar adequação, contudo alguns dados requerem aprovação do CE.</p>
              
              <p>7.13. Os dados que requerem aprovação do CE são:</p>
              
              <ul style="list-style-type: disc; padding-left: 20px;">
                <li>Razão social; Endereço e Escopo</li>
              </ul>
              
              <p>7.14. A Secretaria ao constatar que são os dados que requerem aprovação do CE deve solicitar ao fornecedor que apresente cópia de documentos que comprove a alteração;</p>
              
              <p>7.15. O CE analisa e se estiver de acordo, dá o parecer favorável;</p>
              
              <p>7.16. A Secretaria registra a decisão no SIP, emite novo certificado e, se necessário, o fornecedor deve assinar novo termo de adesão;</p>
              
              <p>7.17. Os dados que requerem emissão de novo certificado são: Razão social; Endereço e Escopo;</p>
              
              <p>7.18. Deve ser observada a quantidade de sistemas de gestão que o fornecedor possui com o Prodfor, no caso de Razão social e Endereço, todos os SG que o fornecedor possui devem ser emitidos. Para a alteração de escopo, deve ser observada para qual SG é a alteração e emitir somente o referido.</p>
              
              <div style="padding-left: 20px;">
                <p>7.18.1. No caso de alteração de Escopo é necessário análise e recomendação do Revisor Técnico e há um procedimento específico para isto.</p>
                <p>7.18.2. O dado que requerem emissão de novo termo de adesão é a Razão social</p>
              </div>
              
              <p>7.19. Os demais dados que não requerem aprovação do CE, a Secretaria pode realizar aprovação no SIP.</p>
            </div>
            
            <h4 style="font-weight: bold; margin-top: 20px;">8. Do cadastro do Auditor PRODFOR</h4>
            
            <div style="padding-left: 20px;">
              <p>8.1. O auditor do Prodfor deve ser preferencialmente auditor indicado por mantenedora do Programa;</p>
              
              <p>8.2. Para realização de cadastro o candidato a auditor deve atender aos pré-requisitos estabelecidos no Regulamento do Prodfor e entrar no site www.prodforsip.com.br e preencher o formulário;</p>
              
              <p>8.3. A Secretaria verifica se todos os campos do formulário estão preenchidos, estando completo, deve encaminhar ao Revisor Técnico que fará análise e recomendação ao Comitê Executivo;</p>
              
              <p>8.4. Se o cadastro não for aprovado pelo CE retorna para o candidato e encerra o atendimento;</p>
              
              <p>8.5. Quando aprovado pelo CE antes dele atuar, deve:</p>
              
              <div style="padding-left: 20px;">
                <p>a) Sendo auditor de mantenedora, deve participar da preparação e sua qualificação deve estar de acordo com regulamento do Prodfor</p>
                
                <p>b) Sendo auditor independente:</p>
                
                <ul style="list-style-type: disc; padding-left: 20px;">
                  <li>Realizar o cadastro de PJ preenchendo o documento Anexo I -- Dados complementares para elaboração do instrumento contratual e também o link de cadastro de fornecedores da Findes no sistema Paradigma <a href="https://portaldecompras.findes.org.br/" target="_blank">https://portaldecompras.findes.org.br/</a>.</li>
                  <li>Assinar o contrato com o IEL de prestação de serviço de auditoria;</li>
                  <li>Informar ao auditor a política de pagamentos do IEL, inclusive as datas mensais para acolhimento de nota fiscal por parte do IEL;</li>
                  <li>Ser questionado se deseja atuar em auditorias com aporte financeiro pelo SGF do Sebrae, informando a forma e o prazo de pagamento para esta modalidade (RPA). Se sim, providenciar a documentação para inclusão como membro da equipe técnica do IEL no SGF conforme orientação da equipe do IEL. Se não, informar ao Revisor Técnico, o auditor não deve ser escalado para auditorias que possuem apoio financeiro do Sebrae.</li>
                </ul>
              </div>
            </div>
            
            <h4 style="font-weight: bold; margin-top: 20px;">9. Dados Coletados, Finalidade e Compartilhamento</h4>
            
            <div style="padding-left: 20px;">
              <p>9.1. Para fins de acesso ao sistema PRODFOR como fornecedor é necessário um cadastro prévio, em que são solicitados os dados da pessoa jurídica e apenas os seguintes dados pessoais, da pessoa física vinculada à organização: nome, e-mail, cargo e telefone;</p>
              
              <p>9.2. Para fins de acesso ao sistema PRODFOR como auditor, é necessário um cadastro prévio, em que são solicitados os seguintes dados pessoais: nome, CPF, e-mail, CEP, logradouro, número, bairro, cidade, telefone, formação (nome do curso, data da realização, carga horária, tipo de curso, entidade), experiência profissional e cadastro da área de interesse dentro do Sistema de Gestão do PRODFOR, dados esses necessários para fins de seleção do interessado auditor no Sistma PRODFOR.</p>
              
              <p>9.3. Para fins de login no sistema, o usuário registrará uma senha que não deverá ser compartilhada, sendo de sua responsabilidade o seu uso e guarda.</p>
              
              <p>9.4. As informações pessoais listadas nos itens 6.1 e 6.2. poderão ser compartilhadas com terceiros, tais como empresas mantenedoras, unicamente fins de execução de serviços, operação e melhorias da aplicação, considerando os serviços disponibilizados e conforme as bases legais previstas na legislação brasileira, incluindo a LGPD e demais regulamentações nacionais sobre proteção de dados pessoais.</p>
              
              <p>9.5. A retenção dos dados pessoais dos usuários dar-se-á apenas pelo tempo necessário para cumprir os propósitos para os quais foram coletados, conforme detalhado na Política de Privacidade, ou enquanto a conta estiver ativa e por um período adicional conforme necessário para:</p>
              
              <div style="padding-left: 20px;">
                <p>9.5.1. Cumprir com as obrigações legais ou regulatórias;</p>
                <p>9.5.2. Caso necessário em processos judiciais, administrativos ou arbitrais;</p>
                <p>9.5.3. Garantir a segurança e a integridade da plataforma;</p>
              </div>
              
              <p>9.6. Após o término do período de retenção, os dados pessoais serão devidamente descartados ou anonimizados, de forma a impedir ou minimizar riscos de uma eventual identificação do usuário, salvo nos casos expressamente autorizados pela legislação aplicável.</p>
              
              <p>9.7. O usuário pode solicitar a exclusão de seus dados pessoais a qualquer tempo, estando ciente que isto poderá inviabilizar o seu acesso ao sistema.</p>
            </div>
            
            <h4 style="font-weight: bold; margin-top: 20px;">10. Alterações deste Termo de Uso</h4>
            
            <div style="padding-left: 20px;">
              <p>10.1. O presente Termo poderá ser alterado a qualquer momento. Saliente-se que sempre atualizado os usuários deste sistema serão devidamente cientificados e atualizados sobre qualquer alteração.</p>
            </div>
            
            <h4 style="font-weight: bold; margin-top: 20px;">11. Lei Aplicável e Jurisdição</h4>
            
            <div style="padding-left: 20px;">
              <p>11.1. Este Termo será regido e interpretado de acordo com as leis do Brasil. Qualquer disputa relacionada a este Termo será submetida à jurisdição exclusiva dos tribunais do Brasil.</p>
            </div>
            
            <h4 style="font-weight: bold; margin-top: 20px;">12. Canal de Comunicação</h4>
            
            <div style="padding-left: 20px;">
              <p>12.1. Para quaisquer dúvidas ou esclarecimentos sobre este Termo, entre em contato através do e-mail <a href="mailto:lgpd@findes.org.br">lgpd@findes.org.br</a> e fale com a Encarregada pelo tratamento dos dados pessoais da FINDES.</p>
            </div>
          </div>
        `,
};



// WEBPACK FOOTER //
// /app/src/environments/resource.ts